/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useAxios } from "~/utils/hooks/useAxios"
import { API_BASE_URL } from "~/config";

const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
const dateFormat2 = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)$/;
const dateOffsetFormat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T([0-9]{2}:){2}[0-9]{2}(?:\.[0-9]{1,9})?[+|-][0-9]{2}:[0-9]{2}$/;

function jsonParseReviver(value: unknown) {
  if (typeof value === "string" && (dateFormat.test(value) || dateFormat2.test(value) || dateOffsetFormat.test(value))) {
    return new Date(value);
  }
  return value;
}

export const useAccessApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const getAccesses = useCallback((
    ): Promise<AccessItemDto[]> => {
        let url_ = baseUrl + "/api/Access";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAccesses(_response);
        });
    },[baseUrl, instance])

    const processGetAccesses = (response: AxiosResponse): Promise<AccessItemDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<AccessItemDto[]>(<any>null);
    }
  
    return useMemo(
      () => ({
            getAccesses,
        }),
      [        getAccesses,
    ],
    );
  };

export const useAISModemApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const removeModem = useCallback((deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/AISModem/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemoveModem(_response);
        });
    },[baseUrl, instance])

    const processRemoveModem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editModem = useCallback((editModem
    : VesselRouterEditDto
    , deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/AISModem/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModem);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditModem(_response);
        });
    },[baseUrl, instance])

    const processEditModem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getModemQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getModem = useCallback((deviceId
    : string
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getModemQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<VesselRouterListDto> => {
        let url_ = baseUrl + "/api/AISModem/{deviceId}?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetModem(_response);
        });
    },[baseUrl, instance])

    const processGetModem = (response: AxiosResponse): Promise<VesselRouterListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<VesselRouterListDto>(<any>null);
    }
    
    const createModem = useCallback((createModem
    : VesselRouterCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/AISModem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createModem);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processCreateModem(_response);
        });
    },[baseUrl, instance])

    const processCreateModem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface listModemsQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const listModems = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: listModemsQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfVesselRouterListDto> => {
        let url_ = baseUrl + "/api/AISModem?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processListModems(_response);
        });
    },[baseUrl, instance])

    const processListModems = (response: AxiosResponse): Promise<PaginatedListOfVesselRouterListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfVesselRouterListDto>(<any>null);
    }
    
    const getRouterConnectionString = useCallback((deviceId
    : string
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/AISModem/{deviceId}/key";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetRouterConnectionString(_response);
        });
    },[baseUrl, instance])

    const processGetRouterConnectionString = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
  
    return useMemo(
      () => ({
            removeModem,
            editModem,
            getModem,
            createModem,
            listModems,
            getRouterConnectionString,
        }),
      [        removeModem,
            editModem,
            getModem,
            createModem,
            listModems,
            getRouterConnectionString,
    ],
    );
  };

export const useArrivalZoneApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addArrivalZone = useCallback((p
    : ArrivalZoneCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ArrivalZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(p);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddArrivalZone(_response);
        });
    },[baseUrl, instance])

    const processAddArrivalZone = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getArrivalZonesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getArrivalZones = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getArrivalZonesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfArrivalZoneListDto> => {
        let url_ = baseUrl + "/api/ArrivalZone?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetArrivalZones(_response);
        });
    },[baseUrl, instance])

    const processGetArrivalZones = (response: AxiosResponse): Promise<PaginatedListOfArrivalZoneListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfArrivalZoneListDto>(<any>null);
    }
    
    const editArrivalZone = useCallback((p
    : ArrivalZoneEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ArrivalZone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(p);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditArrivalZone(_response);
        });
    },[baseUrl, instance])

    const processEditArrivalZone = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getArrivalZone = useCallback((id
    : number
    
    ): Promise<ArrivalZoneDetailsDto> => {
        let url_ = baseUrl + "/api/ArrivalZone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetArrivalZone(_response);
        });
    },[baseUrl, instance])

    const processGetArrivalZone = (response: AxiosResponse): Promise<ArrivalZoneDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ArrivalZoneDetailsDto>(<any>null);
    }
    
    const deleteArrivalZone = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ArrivalZone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteArrivalZone(_response);
        });
    },[baseUrl, instance])

    const processDeleteArrivalZone = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getArrivalZonesByPortId = useCallback((portId
    : number
    
    ): Promise<ArrivalZoneListDto[]> => {
        let url_ = baseUrl + "/api/ArrivalZone/ByPortId/{portId}";
        if (portId === undefined || portId === null)
            throw new Error("The parameter 'portId' must be defined.");
        url_ = url_.replace("{portId}", encodeURIComponent("" + portId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetArrivalZonesByPortId(_response);
        });
    },[baseUrl, instance])

    const processGetArrivalZonesByPortId = (response: AxiosResponse): Promise<ArrivalZoneListDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ArrivalZoneListDto[]>(<any>null);
    }
  
    return useMemo(
      () => ({
            addArrivalZone,
            getArrivalZones,
            editArrivalZone,
            getArrivalZone,
            deleteArrivalZone,
            getArrivalZonesByPortId,
        }),
      [        addArrivalZone,
            getArrivalZones,
            editArrivalZone,
            getArrivalZone,
            deleteArrivalZone,
            getArrivalZonesByPortId,
    ],
    );
  };

export const useBerthApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addBerth = useCallback((b
    : BerthCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddBerth(_response);
        });
    },[baseUrl, instance])

    const processAddBerth = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getBerthsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined, 
        id?: number | undefined
    }
    
    const getBerths = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
    , id
     }: getBerthsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined, id: undefined }): Promise<PaginatedListOfBerthListDto> => {
        let url_ = baseUrl + "/api/Berth?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBerths(_response);
        });
    },[baseUrl, instance])

    const processGetBerths = (response: AxiosResponse): Promise<PaginatedListOfBerthListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfBerthListDto>(<any>null);
    }
    
    const editBerth = useCallback((b
    : BerthEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditBerth(_response);
        });
    },[baseUrl, instance])

    const processEditBerth = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getBerth = useCallback((id
    : number
    
    ): Promise<BerthDetailsDto> => {
        let url_ = baseUrl + "/api/Berth/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBerth(_response);
        });
    },[baseUrl, instance])

    const processGetBerth = (response: AxiosResponse): Promise<BerthDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<BerthDetailsDto>(<any>null);
    }
    
    const deleteBerth = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteBerth(_response);
        });
    },[baseUrl, instance])

    const processDeleteBerth = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getAllBerthsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getAllBerths = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getAllBerthsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfBerthListDto> => {
        let url_ = baseUrl + "/api/Berth/all?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAllBerths(_response);
        });
    },[baseUrl, instance])

    const processGetAllBerths = (response: AxiosResponse): Promise<PaginatedListOfBerthListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfBerthListDto>(<any>null);
    }
    
    const addBerthEvent = useCallback((b
    : BerthEventCreateDto
    , idBerth
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/event";
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddBerthEvent(_response);
        });
    },[baseUrl, instance])

    const processAddBerthEvent = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editBerthEvent = useCallback((b
    : BerthEventEditDto
    , id
    : number
    , idBerth
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditBerthEvent(_response);
        });
    },[baseUrl, instance])

    const processEditBerthEvent = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getBerthEvent = useCallback((id
    : number
    , idBerth
    : string
    
    ): Promise<BerthEventDetailsDto> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBerthEvent(_response);
        });
    },[baseUrl, instance])

    const processGetBerthEvent = (response: AxiosResponse): Promise<BerthEventDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<BerthEventDetailsDto>(<any>null);
    }
    
    const deleteBerthEvent = useCallback((id
    : number
    , idBerth
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteBerthEvent(_response);
        });
    },[baseUrl, instance])

    const processDeleteBerthEvent = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getBerthEventsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getBerthEvents = useCallback((idBerth
    : number
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getBerthEventsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfBerthEventListDto> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Event?";
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBerthEvents(_response);
        });
    },[baseUrl, instance])

    const processGetBerthEvents = (response: AxiosResponse): Promise<PaginatedListOfBerthEventListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfBerthEventListDto>(<any>null);
    }
    
    const addBerthOrder = useCallback((b
    : BerthOrderCreateDto
    , idBerth
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Order";
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddBerthOrder(_response);
        });
    },[baseUrl, instance])

    const processAddBerthOrder = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getBerthOrdersQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getBerthOrders = useCallback((idBerth
    : number
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getBerthOrdersQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfBerthOrderListDto> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Order?";
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBerthOrders(_response);
        });
    },[baseUrl, instance])

    const processGetBerthOrders = (response: AxiosResponse): Promise<PaginatedListOfBerthOrderListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfBerthOrderListDto>(<any>null);
    }
    
    const editBerthOrder = useCallback((b
    : BerthOrderEditDto
    , id
    : number
    , idBerth
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(b);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditBerthOrder(_response);
        });
    },[baseUrl, instance])

    const processEditBerthOrder = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getBerthOrder = useCallback((id
    : number
    , idBerth
    : string
    
    ): Promise<BerthOrderDetailsDto> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBerthOrder(_response);
        });
    },[baseUrl, instance])

    const processGetBerthOrder = (response: AxiosResponse): Promise<BerthOrderDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<BerthOrderDetailsDto>(<any>null);
    }
    
    const deleteBerthOrder = useCallback((id
    : number
    , idBerth
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Berth/{idBerth}/Order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (idBerth === undefined || idBerth === null)
            throw new Error("The parameter 'idBerth' must be defined.");
        url_ = url_.replace("{idBerth}", encodeURIComponent("" + idBerth));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteBerthOrder(_response);
        });
    },[baseUrl, instance])

    const processDeleteBerthOrder = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addBerth,
            getBerths,
            editBerth,
            getBerth,
            deleteBerth,
            getAllBerths,
            addBerthEvent,
            editBerthEvent,
            getBerthEvent,
            deleteBerthEvent,
            getBerthEvents,
            addBerthOrder,
            getBerthOrders,
            editBerthOrder,
            getBerthOrder,
            deleteBerthOrder,
        }),
      [        addBerth,
            getBerths,
            editBerth,
            getBerth,
            deleteBerth,
            getAllBerths,
            addBerthEvent,
            editBerthEvent,
            getBerthEvent,
            deleteBerthEvent,
            getBerthEvents,
            addBerthOrder,
            getBerthOrders,
            editBerthOrder,
            getBerthOrder,
            deleteBerthOrder,
    ],
    );
  };

export const useBookingApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    
    interface getBookingsQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getBookings = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getBookingsQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfBookingDetailsDto> => {
        let url_ = baseUrl + "/api/Booking/List?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBookings(_response);
        });
    },[baseUrl, instance])

    const processGetBookings = (response: AxiosResponse): Promise<PaginatedListOfBookingDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfBookingDetailsDto>(<any>null);
    }
    
    const getBooking = useCallback((id
    : number
    
    ): Promise<BookingDetailsDto> => {
        let url_ = baseUrl + "/api/Booking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetBooking(_response);
        });
    },[baseUrl, instance])

    const processGetBooking = (response: AxiosResponse): Promise<BookingDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<BookingDetailsDto>(<any>null);
    }
    
    const removeBooking = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Booking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemoveBooking(_response);
        });
    },[baseUrl, instance])

    const processRemoveBooking = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const addBooking = useCallback((bookingAdd
    : BookingAddDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Booking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingAdd);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddBooking(_response);
        });
    },[baseUrl, instance])

    const processAddBooking = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editBooking = useCallback((bookingEdit
    : BookingEditDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Booking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditBooking(_response);
        });
    },[baseUrl, instance])

    const processEditBooking = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            getBookings,
            getBooking,
            removeBooking,
            addBooking,
            editBooking,
        }),
      [        getBookings,
            getBooking,
            removeBooking,
            addBooking,
            editBooking,
    ],
    );
  };

export const useCameraClipApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const clipHlsStream = useCallback((clipId
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/CameraClip/{clipId}/HlsStream";
        if (clipId === undefined || clipId === null)
            throw new Error("The parameter 'clipId' must be defined.");
        url_ = url_.replace("{clipId}", encodeURIComponent("" + clipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processClipHlsStream(_response);
        });
    },[baseUrl, instance])

    const processClipHlsStream = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface clipVideoSegmentQueryParams {
        dateTime?: Date | undefined
    }
    
    const clipVideoSegment = useCallback((clipId
    : number
    , 
    { dateTime
     }: clipVideoSegmentQueryParams={ dateTime: undefined }): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/CameraClip/{clipId}/ClipVideoSegment?";
        if (clipId === undefined || clipId === null)
            throw new Error("The parameter 'clipId' must be defined.");
        url_ = url_.replace("{clipId}", encodeURIComponent("" + clipId));
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processClipVideoSegment(_response);
        });
    },[baseUrl, instance])

    const processClipVideoSegment = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface getAllClipsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getAllClips = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getAllClipsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfCameraClipItemDto> => {
        let url_ = baseUrl + "/api/CameraClip?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAllClips(_response);
        });
    },[baseUrl, instance])

    const processGetAllClips = (response: AxiosResponse): Promise<PaginatedListOfCameraClipItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfCameraClipItemDto>(<any>null);
    }
    
    
    interface deleteClipQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const deleteClip = useCallback((clipId
    : number
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: deleteClipQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<void> => {
        let url_ = baseUrl + "/api/CameraClip/{clipId}?";
        if (clipId === undefined || clipId === null)
            throw new Error("The parameter 'clipId' must be defined.");
        url_ = url_.replace("{clipId}", encodeURIComponent("" + clipId));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteClip(_response);
        });
    },[baseUrl, instance])

    const processDeleteClip = (response: AxiosResponse): Promise<void> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(<any>null);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<void>(<any>null);
    }
    
    const editClip = useCallback((clipId
    : number
    , editClipDto
    : CameraEditClipDto
    
    ): Promise<CameraClipItemDto> => {
        let url_ = baseUrl + "/api/CameraClip/{clipId}";
        if (clipId === undefined || clipId === null)
            throw new Error("The parameter 'clipId' must be defined.");
        url_ = url_.replace("{clipId}", encodeURIComponent("" + clipId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editClipDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditClip(_response);
        });
    },[baseUrl, instance])

    const processEditClip = (response: AxiosResponse): Promise<CameraClipItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<CameraClipItemDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            clipHlsStream,
            clipVideoSegment,
            getAllClips,
            deleteClip,
            editClip,
        }),
      [        clipHlsStream,
            clipVideoSegment,
            getAllClips,
            deleteClip,
            editClip,
    ],
    );
  };

export const useCameraApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    
    interface getCamerasQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getCameras = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getCamerasQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfCameraItemDto> => {
        let url_ = baseUrl + "/api/Camera?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetCameras(_response);
        });
    },[baseUrl, instance])

    const processGetCameras = (response: AxiosResponse): Promise<PaginatedListOfCameraItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfCameraItemDto>(<any>null);
    }
    
    const addCamera = useCallback((camera
    : CameraCreateDto
    
    ): Promise<void> => {
        let url_ = baseUrl + "/api/Camera";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(camera);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddCamera(_response);
        });
    },[baseUrl, instance])

    const processAddCamera = (response: AxiosResponse): Promise<void> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<void>(<any>null);
    }
    
    const editCamera = useCallback((camera
    : CameraEditDto
    , cameraId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(camera);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditCamera(_response);
        });
    },[baseUrl, instance])

    const processEditCamera = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteCamera = useCallback((cameraId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteCamera(_response);
        });
    },[baseUrl, instance])

    const processDeleteCamera = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const liveHlsStream = useCallback((cameraId
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/LiveHlsStream";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processLiveHlsStream(_response);
        });
    },[baseUrl, instance])

    const processLiveHlsStream = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    const liveVideoSegment = useCallback((cameraId
    : number
    , sessionId
    : string
    , videoSegmentFileName
    : string
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/Session/{sessionId}/LiveVideoSegment/{videoSegmentFileName}";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (videoSegmentFileName === undefined || videoSegmentFileName === null)
            throw new Error("The parameter 'videoSegmentFileName' must be defined.");
        url_ = url_.replace("{videoSegmentFileName}", encodeURIComponent("" + videoSegmentFileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processLiveVideoSegment(_response);
        });
    },[baseUrl, instance])

    const processLiveVideoSegment = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface recordedVideoSegmentQueryParams {
        dateTime?: Date | undefined
    }
    
    const recordedVideoSegment = useCallback((cameraId
    : number
    , 
    { dateTime
     }: recordedVideoSegmentQueryParams={ dateTime: undefined }): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/RecordedVideoSegment?";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRecordedVideoSegment(_response);
        });
    },[baseUrl, instance])

    const processRecordedVideoSegment = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    const noRecordingVideoSegment = useCallback((cameraId
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/NoRecordingVideoSegment";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processNoRecordingVideoSegment(_response);
        });
    },[baseUrl, instance])

    const processNoRecordingVideoSegment = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface recordedHlsStreamQueryParams {
        dateTime?: Date | undefined, 
        durationSeconds?: number | undefined
    }
    
    const recordedHlsStream = useCallback((cameraId
    : number
    , 
    { dateTime
    , durationSeconds
     }: recordedHlsStreamQueryParams={ dateTime: undefined, durationSeconds: undefined }): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/RecordedHlsStream?";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&";
        if (durationSeconds === null)
            throw new Error("The parameter 'durationSeconds' cannot be null.");
        else if (durationSeconds !== undefined)
            url_ += "durationSeconds=" + encodeURIComponent("" + durationSeconds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRecordedHlsStream(_response);
        });
    },[baseUrl, instance])

    const processRecordedHlsStream = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface recordedDatesQueryParams {
        dateMin?: Date | undefined, 
        dateMax?: Date | undefined, 
        utcOffsetHours?: number | null | undefined
    }
    
    const recordedDates = useCallback((cameraId
    : number
    , 
    { dateMin
    , dateMax
    , utcOffsetHours
     }: recordedDatesQueryParams={ dateMin: undefined, dateMax: undefined, utcOffsetHours: undefined }): Promise<Date[]> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/RecordedDates?";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (dateMin === null)
            throw new Error("The parameter 'dateMin' cannot be null.");
        else if (dateMin !== undefined)
            url_ += "dateMin=" + encodeURIComponent(dateMin ? "" + dateMin.toJSON() : "") + "&";
        if (dateMax === null)
            throw new Error("The parameter 'dateMax' cannot be null.");
        else if (dateMax !== undefined)
            url_ += "dateMax=" + encodeURIComponent(dateMax ? "" + dateMax.toJSON() : "") + "&";
        if (utcOffsetHours !== undefined && utcOffsetHours !== null)
            url_ += "utcOffsetHours=" + encodeURIComponent("" + utcOffsetHours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRecordedDates(_response);
        });
    },[baseUrl, instance])

    const processRecordedDates = (response: AxiosResponse): Promise<Date[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<Date[]>(<any>null);
    }
    
    
    interface recordedTimesQueryParams {
        date?: Date | undefined
    }
    
    const recordedTimes = useCallback((cameraId
    : number
    , 
    { date
     }: recordedTimesQueryParams={ date: undefined }): Promise<CameraTimesItemDto[]> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/RecordedTimes?";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRecordedTimes(_response);
        });
    },[baseUrl, instance])

    const processRecordedTimes = (response: AxiosResponse): Promise<CameraTimesItemDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<CameraTimesItemDto[]>(<any>null);
    }
    
    const saveClip = useCallback((cameraId
    : number
    , cameraSaveClip
    : CameraSaveClipDto
    
    ): Promise<CameraClipItemDto> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/SaveClip";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cameraSaveClip);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSaveClip(_response);
        });
    },[baseUrl, instance])

    const processSaveClip = (response: AxiosResponse): Promise<CameraClipItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<CameraClipItemDto>(<any>null);
    }
    
    
    interface getClipsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getClips = useCallback((cameraId
    : number
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getClipsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfCameraClipItemDto> => {
        let url_ = baseUrl + "/api/Camera/{cameraId}/Clips?";
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetClips(_response);
        });
    },[baseUrl, instance])

    const processGetClips = (response: AxiosResponse): Promise<PaginatedListOfCameraClipItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfCameraClipItemDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            getCameras,
            addCamera,
            editCamera,
            deleteCamera,
            liveHlsStream,
            liveVideoSegment,
            recordedVideoSegment,
            noRecordingVideoSegment,
            recordedHlsStream,
            recordedDates,
            recordedTimes,
            saveClip,
            getClips,
        }),
      [        getCameras,
            addCamera,
            editCamera,
            deleteCamera,
            liveHlsStream,
            liveVideoSegment,
            recordedVideoSegment,
            noRecordingVideoSegment,
            recordedHlsStream,
            recordedDates,
            recordedTimes,
            saveClip,
            getClips,
    ],
    );
  };

export const useComparisonLevelApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addComparisonLevel = useCallback((comparisonLevelCreate
    : ComparisonLevelCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ComparisonLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comparisonLevelCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddComparisonLevel(_response);
        });
    },[baseUrl, instance])

    const processAddComparisonLevel = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getComparisonLevelsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getComparisonLevels = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getComparisonLevelsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfComparisonLevelListDto> => {
        let url_ = baseUrl + "/api/ComparisonLevel?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetComparisonLevels(_response);
        });
    },[baseUrl, instance])

    const processGetComparisonLevels = (response: AxiosResponse): Promise<PaginatedListOfComparisonLevelListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfComparisonLevelListDto>(<any>null);
    }
    
    const editComparisonLevel = useCallback((comparisonLevelEdit
    : ComparisonLevelEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ComparisonLevel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comparisonLevelEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditComparisonLevel(_response);
        });
    },[baseUrl, instance])

    const processEditComparisonLevel = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteComparisonLevel = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ComparisonLevel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteComparisonLevel(_response);
        });
    },[baseUrl, instance])

    const processDeleteComparisonLevel = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addComparisonLevel,
            getComparisonLevels,
            editComparisonLevel,
            deleteComparisonLevel,
        }),
      [        addComparisonLevel,
            getComparisonLevels,
            editComparisonLevel,
            deleteComparisonLevel,
    ],
    );
  };

export const useCoordinateSystemApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addCoordinateSystem = useCallback((coordinateSystemCreate
    : CoordinateSystemCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/CoordinateSystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coordinateSystemCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddCoordinateSystem(_response);
        });
    },[baseUrl, instance])

    const processAddCoordinateSystem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getCoordinateSystemsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getCoordinateSystems = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getCoordinateSystemsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfCoordinateSystemListDto> => {
        let url_ = baseUrl + "/api/CoordinateSystem?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetCoordinateSystems(_response);
        });
    },[baseUrl, instance])

    const processGetCoordinateSystems = (response: AxiosResponse): Promise<PaginatedListOfCoordinateSystemListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfCoordinateSystemListDto>(<any>null);
    }
    
    const editCoordinateSystem = useCallback((coordinateSystemEdit
    : CoordinateSystemEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/CoordinateSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coordinateSystemEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditCoordinateSystem(_response);
        });
    },[baseUrl, instance])

    const processEditCoordinateSystem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteCoordinateSystem = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/CoordinateSystem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteCoordinateSystem(_response);
        });
    },[baseUrl, instance])

    const processDeleteCoordinateSystem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addCoordinateSystem,
            getCoordinateSystems,
            editCoordinateSystem,
            deleteCoordinateSystem,
        }),
      [        addCoordinateSystem,
            getCoordinateSystems,
            editCoordinateSystem,
            deleteCoordinateSystem,
    ],
    );
  };

export const useDamApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addDam = useCallback((d
    : DamCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Dam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(d);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddDam(_response);
        });
    },[baseUrl, instance])

    const processAddDam = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getDamsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getDams = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getDamsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfDamListDto> => {
        let url_ = baseUrl + "/api/Dam?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetDams(_response);
        });
    },[baseUrl, instance])

    const processGetDams = (response: AxiosResponse): Promise<PaginatedListOfDamListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfDamListDto>(<any>null);
    }
    
    const editDam = useCallback((d
    : DamEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Dam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(d);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditDam(_response);
        });
    },[baseUrl, instance])

    const processEditDam = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getDam = useCallback((id
    : number
    
    ): Promise<DamDetailsDto> => {
        let url_ = baseUrl + "/api/Dam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetDam(_response);
        });
    },[baseUrl, instance])

    const processGetDam = (response: AxiosResponse): Promise<DamDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<DamDetailsDto>(<any>null);
    }
    
    const deleteDam = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Dam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteDam(_response);
        });
    },[baseUrl, instance])

    const processDeleteDam = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const addDamOperation = useCallback((d
    : DamOperationCreateDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Dam/{id}/Operation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(d);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddDamOperation(_response);
        });
    },[baseUrl, instance])

    const processAddDamOperation = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editDamOperation = useCallback((d
    : DamOperationEditDto
    , id
    : number
    , opId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Dam/{id}/Operation/{opId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (opId === undefined || opId === null)
            throw new Error("The parameter 'opId' must be defined.");
        url_ = url_.replace("{opId}", encodeURIComponent("" + opId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(d);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditDamOperation(_response);
        });
    },[baseUrl, instance])

    const processEditDamOperation = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getDamOperationsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getDamOperations = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getDamOperationsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfDamOperationListDto> => {
        let url_ = baseUrl + "/api/Dam/Operation?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetDamOperations(_response);
        });
    },[baseUrl, instance])

    const processGetDamOperations = (response: AxiosResponse): Promise<PaginatedListOfDamOperationListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfDamOperationListDto>(<any>null);
    }
    
    const getDamOperation = useCallback((id
    : number
    
    ): Promise<DamOperationDetailsDto> => {
        let url_ = baseUrl + "/api/Dam/Operation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetDamOperation(_response);
        });
    },[baseUrl, instance])

    const processGetDamOperation = (response: AxiosResponse): Promise<DamOperationDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<DamOperationDetailsDto>(<any>null);
    }
    
    const deleteDamOperation = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Dam/Operation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteDamOperation(_response);
        });
    },[baseUrl, instance])

    const processDeleteDamOperation = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addDam,
            getDams,
            editDam,
            getDam,
            deleteDam,
            addDamOperation,
            editDamOperation,
            getDamOperations,
            getDamOperation,
            deleteDamOperation,
        }),
      [        addDam,
            getDams,
            editDam,
            getDam,
            deleteDam,
            addDamOperation,
            editDamOperation,
            getDamOperations,
            getDamOperation,
            deleteDamOperation,
    ],
    );
  };

export const useDesignMaterialApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addDesignMaterial = useCallback((designMaterialToCreate
    : DesignMaterialUpdateDto
    
    ): Promise<ReturnNodeDto> => {
        let url_ = baseUrl + "/api/DesignMaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(designMaterialToCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddDesignMaterial(_response);
        });
    },[baseUrl, instance])

    const processAddDesignMaterial = (response: AxiosResponse): Promise<ReturnNodeDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto>(<any>null);
    }
    
    
    interface getDesignMaterialsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getDesignMaterials = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getDesignMaterialsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfDesignMaterialItemDto> => {
        let url_ = baseUrl + "/api/DesignMaterial?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetDesignMaterials(_response);
        });
    },[baseUrl, instance])

    const processGetDesignMaterials = (response: AxiosResponse): Promise<PaginatedListOfDesignMaterialItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfDesignMaterialItemDto>(<any>null);
    }
    
    const editDesignMaterial = useCallback((designMaterialToEdit
    : DesignMaterialUpdateDto
    , id
    : number
    
    ): Promise<ReturnNodeDto> => {
        let url_ = baseUrl + "/api/DesignMaterial/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(designMaterialToEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditDesignMaterial(_response);
        });
    },[baseUrl, instance])

    const processEditDesignMaterial = (response: AxiosResponse): Promise<ReturnNodeDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto>(<any>null);
    }
    
    const getDesignMaterial = useCallback((id
    : number
    
    ): Promise<DesignMaterialItemDto> => {
        let url_ = baseUrl + "/api/DesignMaterial/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetDesignMaterial(_response);
        });
    },[baseUrl, instance])

    const processGetDesignMaterial = (response: AxiosResponse): Promise<DesignMaterialItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<DesignMaterialItemDto>(<any>null);
    }
    
    const deleteDesignMaterial = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/DesignMaterial/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteDesignMaterial(_response);
        });
    },[baseUrl, instance])

    const processDeleteDesignMaterial = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addDesignMaterial,
            getDesignMaterials,
            editDesignMaterial,
            getDesignMaterial,
            deleteDesignMaterial,
        }),
      [        addDesignMaterial,
            getDesignMaterials,
            editDesignMaterial,
            getDesignMaterial,
            deleteDesignMaterial,
    ],
    );
  };

export const useEquipmentApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    
    interface getEquipmentQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getEquipment = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getEquipmentQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment/List?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetEquipment(_response);
        });
    },[baseUrl, instance])

    const processGetEquipment = (response: AxiosResponse): Promise<PaginatedListOfEquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEquipmentDetailsDto>(<any>null);
    }
    
    
    interface getEquipmentByTypeQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getEquipmentByType = useCallback((typeId
    : number
    , 
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getEquipmentByTypeQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment/List/Type/{typeId}?";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined.");
        url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetEquipmentByType(_response);
        });
    },[baseUrl, instance])

    const processGetEquipmentByType = (response: AxiosResponse): Promise<PaginatedListOfEquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEquipmentDetailsDto>(<any>null);
    }
    
    
    interface getVehiclesQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getVehicles = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getVehiclesQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment/List/Vehicle?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetVehicles(_response);
        });
    },[baseUrl, instance])

    const processGetVehicles = (response: AxiosResponse): Promise<PaginatedListOfEquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEquipmentDetailsDto>(<any>null);
    }
    
    
    interface getWaterCraftsQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getWaterCrafts = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getWaterCraftsQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment/List/WaterCraft?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWaterCrafts(_response);
        });
    },[baseUrl, instance])

    const processGetWaterCrafts = (response: AxiosResponse): Promise<PaginatedListOfEquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEquipmentDetailsDto>(<any>null);
    }
    
    
    interface getWorkEquipmentQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getWorkEquipment = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getWorkEquipmentQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment/List/WorkEquipment?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWorkEquipment(_response);
        });
    },[baseUrl, instance])

    const processGetWorkEquipment = (response: AxiosResponse): Promise<PaginatedListOfEquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEquipmentDetailsDto>(<any>null);
    }
    
    const addEquipment = useCallback((equipmentAdd
    : EquipmentAddDto
    
    ): Promise<EquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentAdd);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddEquipment(_response);
        });
    },[baseUrl, instance])

    const processAddEquipment = (response: AxiosResponse): Promise<EquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<EquipmentDetailsDto>(<any>null);
    }
    
    const editEquipment = useCallback((id
    : number
    , equipmentEdit
    : EquipmentEditDto
    
    ): Promise<EquipmentDetailsDto> => {
        let url_ = baseUrl + "/api/Equipment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditEquipment(_response);
        });
    },[baseUrl, instance])

    const processEditEquipment = (response: AxiosResponse): Promise<EquipmentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<EquipmentDetailsDto>(<any>null);
    }
    
    const removeEquipment = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Equipment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemoveEquipment(_response);
        });
    },[baseUrl, instance])

    const processRemoveEquipment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getEquipmentTypes = useCallback((
    ): Promise<EquipmentTypeListDto[]> => {
        let url_ = baseUrl + "/api/Equipment/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetEquipmentTypes(_response);
        });
    },[baseUrl, instance])

    const processGetEquipmentTypes = (response: AxiosResponse): Promise<EquipmentTypeListDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<EquipmentTypeListDto[]>(<any>null);
    }
    
    const addEquipmentType = useCallback((equipmentTypeAdd
    : EquipmentTypeAddDto
    
    ): Promise<EquipmentTypeListDto> => {
        let url_ = baseUrl + "/api/Equipment/Type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentTypeAdd);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddEquipmentType(_response);
        });
    },[baseUrl, instance])

    const processAddEquipmentType = (response: AxiosResponse): Promise<EquipmentTypeListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<EquipmentTypeListDto>(<any>null);
    }
    
    const editEquipmentType = useCallback((id
    : number
    , equipmentTypeEdit
    : EquipmentTypeEditDto
    
    ): Promise<EquipmentTypeListDto> => {
        let url_ = baseUrl + "/api/Equipment/Type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentTypeEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditEquipmentType(_response);
        });
    },[baseUrl, instance])

    const processEditEquipmentType = (response: AxiosResponse): Promise<EquipmentTypeListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<EquipmentTypeListDto>(<any>null);
    }
    
    const removeEquipmentType = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Equipment/Type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemoveEquipmentType(_response);
        });
    },[baseUrl, instance])

    const processRemoveEquipmentType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editLink = useCallback((editTrackerLink
    : EquipmentTrackerLinkDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Equipment/Link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editTrackerLink);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditLink(_response);
        });
    },[baseUrl, instance])

    const processEditLink = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            getEquipment,
            getEquipmentByType,
            getVehicles,
            getWaterCrafts,
            getWorkEquipment,
            addEquipment,
            editEquipment,
            removeEquipment,
            getEquipmentTypes,
            addEquipmentType,
            editEquipmentType,
            removeEquipmentType,
            editLink,
        }),
      [        getEquipment,
            getEquipmentByType,
            getVehicles,
            getWaterCrafts,
            getWorkEquipment,
            addEquipment,
            editEquipment,
            removeEquipment,
            getEquipmentTypes,
            addEquipmentType,
            editEquipmentType,
            removeEquipmentType,
            editLink,
    ],
    );
  };

export const useEventApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addEvent = useCallback((eventCreate
    : EventCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddEvent(_response);
        });
    },[baseUrl, instance])

    const processAddEvent = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getEventsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getEvents = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getEventsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEventListDto> => {
        let url_ = baseUrl + "/api/Event?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetEvents(_response);
        });
    },[baseUrl, instance])

    const processGetEvents = (response: AxiosResponse): Promise<PaginatedListOfEventListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEventListDto>(<any>null);
    }
    
    const editEvent = useCallback((eventEdit
    : EventEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditEvent(_response);
        });
    },[baseUrl, instance])

    const processEditEvent = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getEvent = useCallback((id
    : number
    
    ): Promise<EventDetailsDto> => {
        let url_ = baseUrl + "/api/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetEvent(_response);
        });
    },[baseUrl, instance])

    const processGetEvent = (response: AxiosResponse): Promise<EventDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<EventDetailsDto>(<any>null);
    }
    
    const deleteEvent = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteEvent(_response);
        });
    },[baseUrl, instance])

    const processDeleteEvent = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addEvent,
            getEvents,
            editEvent,
            getEvent,
            deleteEvent,
        }),
      [        addEvent,
            getEvents,
            editEvent,
            getEvent,
            deleteEvent,
    ],
    );
  };

export const useEventTypeApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addEventType = useCallback((eventTypeCreate
    : EventTypeCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/EventType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventTypeCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddEventType(_response);
        });
    },[baseUrl, instance])

    const processAddEventType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getEventTypesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getEventTypes = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getEventTypesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfEventTypeListDto> => {
        let url_ = baseUrl + "/api/EventType?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetEventTypes(_response);
        });
    },[baseUrl, instance])

    const processGetEventTypes = (response: AxiosResponse): Promise<PaginatedListOfEventTypeListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfEventTypeListDto>(<any>null);
    }
    
    const editEventType = useCallback((eventTypeEdit
    : EventTypeEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/EventType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventTypeEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditEventType(_response);
        });
    },[baseUrl, instance])

    const processEditEventType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteEventType = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/EventType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteEventType(_response);
        });
    },[baseUrl, instance])

    const processDeleteEventType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addEventType,
            getEventTypes,
            editEventType,
            deleteEventType,
        }),
      [        addEventType,
            getEventTypes,
            editEventType,
            deleteEventType,
    ],
    );
  };

export const useExternalApiApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const generateApiKey = useCallback((dto
    : ExternalApiKeyCreateDto
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/ExternalApi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGenerateApiKey(_response);
        });
    },[baseUrl, instance])

    const processGenerateApiKey = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
    
    
    interface getApikeysQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getApikeys = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getApikeysQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfExternalApiKeyListDto> => {
        let url_ = baseUrl + "/api/ExternalApi?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetApikeys(_response);
        });
    },[baseUrl, instance])

    const processGetApikeys = (response: AxiosResponse): Promise<PaginatedListOfExternalApiKeyListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfExternalApiKeyListDto>(<any>null);
    }
    
    const deleteApikey = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/ExternalApi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteApikey(_response);
        });
    },[baseUrl, instance])

    const processDeleteApikey = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getAtonUnitsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined, 
    }
    
    const getAtonUnits = useCallback((apiKey
    ?: string
     | null | undefined, 
    { page
    , pageSize
    , sortField
    , descending
    , search
    ,  }: getAtonUnitsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined,  }): Promise<PaginatedListOfAtonUnit> => {
        let url_ = baseUrl + "/api/ExternalApi/AtonUnit?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAtonUnits(_response);
        });
    },[baseUrl, instance])

    const processGetAtonUnits = (response: AxiosResponse): Promise<PaginatedListOfAtonUnit> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfAtonUnit>(<any>null);
    }
    
    const getSdGroups = useCallback((apiKey
    ?: string
     | null | undefined
    ): Promise<SdGroup[]> => {
        let url_ = baseUrl + "/api/ExternalApi/SdGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSdGroups(_response);
        });
    },[baseUrl, instance])

    const processGetSdGroups = (response: AxiosResponse): Promise<SdGroup[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SdGroup[]>(<any>null);
    }
    
    const getAtonUnit = useCallback((id
    : number
    , apiKey
    ?: string
     | null | undefined
    ): Promise<AtonUnitDetails> => {
        let url_ = baseUrl + "/api/ExternalApi/AtonUnit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAtonUnit(_response);
        });
    },[baseUrl, instance])

    const processGetAtonUnit = (response: AxiosResponse): Promise<AtonUnitDetails> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<AtonUnitDetails>(<any>null);
    }
    
    const getOpenApi = useCallback((apiKey
    ?: string
     | null | undefined
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/ExternalApi/openapi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "apiKey": apiKey !== undefined && apiKey !== null ? "" + apiKey : "",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOpenApi(_response);
        });
    },[baseUrl, instance])

    const processGetOpenApi = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            generateApiKey,
            getApikeys,
            deleteApikey,
            getAtonUnits,
            getSdGroups,
            getAtonUnit,
            getOpenApi,
        }),
      [        generateApiKey,
            getApikeys,
            deleteApikey,
            getAtonUnits,
            getSdGroups,
            getAtonUnit,
            getOpenApi,
    ],
    );
  };

export const useFairwayApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const editFairway = useCallback((fairwayToEdit
    : FairwayEditDto
    , fairwayId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Fairway/{fairwayId}";
        if (fairwayId === undefined || fairwayId === null)
            throw new Error("The parameter 'fairwayId' must be defined.");
        url_ = url_.replace("{fairwayId}", encodeURIComponent("" + fairwayId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fairwayToEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditFairway(_response);
        });
    },[baseUrl, instance])

    const processEditFairway = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getFairway = useCallback((fairwayId
    : number
    
    ): Promise<FairwayDetailsDto> => {
        let url_ = baseUrl + "/api/Fairway/{fairwayId}";
        if (fairwayId === undefined || fairwayId === null)
            throw new Error("The parameter 'fairwayId' must be defined.");
        url_ = url_.replace("{fairwayId}", encodeURIComponent("" + fairwayId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFairway(_response);
        });
    },[baseUrl, instance])

    const processGetFairway = (response: AxiosResponse): Promise<FairwayDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FairwayDetailsDto>(<any>null);
    }
    
    
    interface getFairwaysQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getFairways = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getFairwaysQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfFairwayListDto> => {
        let url_ = baseUrl + "/api/Fairway?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFairways(_response);
        });
    },[baseUrl, instance])

    const processGetFairways = (response: AxiosResponse): Promise<PaginatedListOfFairwayListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfFairwayListDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            editFairway,
            getFairway,
            getFairways,
        }),
      [        editFairway,
            getFairway,
            getFairways,
    ],
    );
  };

export const useFerryApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addFerry = useCallback((f
    : FerryCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Ferry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(f);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddFerry(_response);
        });
    },[baseUrl, instance])

    const processAddFerry = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getFerriesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getFerries = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getFerriesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfFerryListDto> => {
        let url_ = baseUrl + "/api/Ferry?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFerries(_response);
        });
    },[baseUrl, instance])

    const processGetFerries = (response: AxiosResponse): Promise<PaginatedListOfFerryListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfFerryListDto>(<any>null);
    }
    
    const editFerry = useCallback((f
    : FerryEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Ferry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(f);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditFerry(_response);
        });
    },[baseUrl, instance])

    const processEditFerry = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getFerry = useCallback((id
    : number
    
    ): Promise<FerryDetailsDto> => {
        let url_ = baseUrl + "/api/Ferry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFerry(_response);
        });
    },[baseUrl, instance])

    const processGetFerry = (response: AxiosResponse): Promise<FerryDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FerryDetailsDto>(<any>null);
    }
    
    const deleteFerry = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Ferry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteFerry(_response);
        });
    },[baseUrl, instance])

    const processDeleteFerry = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addFerry,
            getFerries,
            editFerry,
            getFerry,
            deleteFerry,
        }),
      [        addFerry,
            getFerries,
            editFerry,
            getFerry,
            deleteFerry,
    ],
    );
  };

export const useFileApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addFolder = useCallback((folder
    : FolderAddDto
    
    ): Promise<ReturnNodeDto> => {
        let url_ = baseUrl + "/api/File";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(folder);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddFolder(_response);
        });
    },[baseUrl, instance])

    const processAddFolder = (response: AxiosResponse): Promise<ReturnNodeDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto>(<any>null);
    }
    
    const moveItem = useCallback((dto
    : MoveItemDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/File";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processMoveItem(_response);
        });
    },[baseUrl, instance])

    const processMoveItem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getNodesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getNodes = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getNodesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<FolderReturnDto> => {
        let url_ = baseUrl + "/api/File?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetNodes(_response);
        });
    },[baseUrl, instance])

    const processGetNodes = (response: AxiosResponse): Promise<FolderReturnDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FolderReturnDto>(<any>null);
    }
    
    const renameItem = useCallback((dto
    : NodeRenameDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRenameItem(_response);
        });
    },[baseUrl, instance])

    const processRenameItem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteItem = useCallback((id
    : number
    , folderDeletePermission
    ?: boolean
     | undefined
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(folderDeletePermission);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteItem(_response);
        });
    },[baseUrl, instance])

    const processDeleteItem = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const uploadFile = useCallback((id
    : number
    
    ): Promise<NewNodeInfoDto[]> => {
        let url_ = baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUploadFile(_response);
        });
    },[baseUrl, instance])

    const processUploadFile = (response: AxiosResponse): Promise<NewNodeInfoDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = JSON.parse(resultData415, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<NewNodeInfoDto[]>(<any>null);
    }
    
    const getFile = useCallback((id
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFile(_response);
        });
    },[baseUrl, instance])

    const processGetFile = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    const shareFile = useCallback((dto
    : NodeShareDto
    , id
    : number
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/File/Share/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processShareFile(_response);
        });
    },[baseUrl, instance])

    const processShareFile = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
    
    const deleteSharedFile = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/File/Share/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteSharedFile(_response);
        });
    },[baseUrl, instance])

    const processDeleteSharedFile = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getSharedFile = useCallback((key
    : string
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/File/Share/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSharedFile(_response);
        });
    },[baseUrl, instance])

    const processGetSharedFile = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface getSharedFilesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getSharedFiles = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getSharedFilesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfSharedFileListDto> => {
        let url_ = baseUrl + "/api/File/Share?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSharedFiles(_response);
        });
    },[baseUrl, instance])

    const processGetSharedFiles = (response: AxiosResponse): Promise<PaginatedListOfSharedFileListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfSharedFileListDto>(<any>null);
    }
    
    const getCesiumTileset = useCallback((id
    : number
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/File/Cesium/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetCesiumTileset(_response);
        });
    },[baseUrl, instance])

    const processGetCesiumTileset = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
    
    const getGeoJson = useCallback((id
    : number
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/File/GeoJson/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetGeoJson(_response);
        });
    },[baseUrl, instance])

    const processGetGeoJson = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
  
    return useMemo(
      () => ({
            addFolder,
            moveItem,
            getNodes,
            renameItem,
            deleteItem,
            uploadFile,
            getFile,
            shareFile,
            deleteSharedFile,
            getSharedFile,
            getSharedFiles,
            getCesiumTileset,
            getGeoJson,
        }),
      [        addFolder,
            moveItem,
            getNodes,
            renameItem,
            deleteItem,
            uploadFile,
            getFile,
            shareFile,
            deleteSharedFile,
            getSharedFile,
            getSharedFiles,
            getCesiumTileset,
            getGeoJson,
    ],
    );
  };

export const useFleetApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addFleet = useCallback((fleetCreate
    : FleetCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Fleet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fleetCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddFleet(_response);
        });
    },[baseUrl, instance])

    const processAddFleet = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getFleetsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getFleets = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getFleetsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfFleetListDto> => {
        let url_ = baseUrl + "/api/Fleet?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFleets(_response);
        });
    },[baseUrl, instance])

    const processGetFleets = (response: AxiosResponse): Promise<PaginatedListOfFleetListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfFleetListDto>(<any>null);
    }
    
    const editFleet = useCallback((fleetEdit
    : FleetEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Fleet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fleetEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditFleet(_response);
        });
    },[baseUrl, instance])

    const processEditFleet = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getFleet = useCallback((id
    : number
    
    ): Promise<FleetDetailsDto> => {
        let url_ = baseUrl + "/api/Fleet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFleet(_response);
        });
    },[baseUrl, instance])

    const processGetFleet = (response: AxiosResponse): Promise<FleetDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FleetDetailsDto>(<any>null);
    }
    
    const deleteFleet = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Fleet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteFleet(_response);
        });
    },[baseUrl, instance])

    const processDeleteFleet = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const addFleetItems = useCallback((itemsToAdd
    : FleetItemIdDto[]
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Fleet/{id}/Items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemsToAdd);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddFleetItems(_response);
        });
    },[baseUrl, instance])

    const processAddFleetItems = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteFleetItems = useCallback((itemsToDelete
    : FleetItemIdDto[]
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Fleet/{id}/Items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemsToDelete);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteFleetItems(_response);
        });
    },[baseUrl, instance])

    const processDeleteFleetItems = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addFleet,
            getFleets,
            editFleet,
            getFleet,
            deleteFleet,
            addFleetItems,
            deleteFleetItems,
        }),
      [        addFleet,
            getFleets,
            editFleet,
            getFleet,
            deleteFleet,
            addFleetItems,
            deleteFleetItems,
    ],
    );
  };

export const useGeopickingApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addGeopicking = useCallback((geopickingToCreate
    : GeopickingCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Geopicking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(geopickingToCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddGeopicking(_response);
        });
    },[baseUrl, instance])

    const processAddGeopicking = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getGeopickingsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getGeopickings = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getGeopickingsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfGeopickingItemDto> => {
        let url_ = baseUrl + "/api/Geopicking?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetGeopickings(_response);
        });
    },[baseUrl, instance])

    const processGetGeopickings = (response: AxiosResponse): Promise<PaginatedListOfGeopickingItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfGeopickingItemDto>(<any>null);
    }
    
    const editGeopicking = useCallback((geopickingToEdit
    : GeopickingEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Geopicking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(geopickingToEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditGeopicking(_response);
        });
    },[baseUrl, instance])

    const processEditGeopicking = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getGeopicking = useCallback((id
    : number
    
    ): Promise<GeopickingItemDto> => {
        let url_ = baseUrl + "/api/Geopicking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetGeopicking(_response);
        });
    },[baseUrl, instance])

    const processGetGeopicking = (response: AxiosResponse): Promise<GeopickingItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<GeopickingItemDto>(<any>null);
    }
    
    const deleteGeopicking = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Geopicking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteGeopicking(_response);
        });
    },[baseUrl, instance])

    const processDeleteGeopicking = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addGeopicking,
            getGeopickings,
            editGeopicking,
            getGeopicking,
            deleteGeopicking,
        }),
      [        addGeopicking,
            getGeopickings,
            editGeopicking,
            getGeopicking,
            deleteGeopicking,
    ],
    );
  };

export const useMap3DObjectApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const updateFileInfo = useCallback((
    ): Promise<ReturnNodeDto> => {
        let url_ = baseUrl + "/api/Map3DObject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUpdateFileInfo(_response);
        });
    },[baseUrl, instance])

    const processUpdateFileInfo = (response: AxiosResponse): Promise<ReturnNodeDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto>(<any>null);
    }
    
    const addMap3DObject = useCallback((f
    : Map3DObjectCreateDto
    
    ): Promise<ReturnNodeDto> => {
        let url_ = baseUrl + "/api/Map3DObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(f);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddMap3DObject(_response);
        });
    },[baseUrl, instance])

    const processAddMap3DObject = (response: AxiosResponse): Promise<ReturnNodeDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto>(<any>null);
    }
    
    
    interface getAvailableObjectsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getAvailableObjects = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getAvailableObjectsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfMap3DObjectListDto> => {
        let url_ = baseUrl + "/api/Map3DObject?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAvailableObjects(_response);
        });
    },[baseUrl, instance])

    const processGetAvailableObjects = (response: AxiosResponse): Promise<PaginatedListOfMap3DObjectListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfMap3DObjectListDto>(<any>null);
    }
    
    const getMapAreaMapObject = useCallback((id
    : number
    
    ): Promise<Map3DObjectDetailsDto> => {
        let url_ = baseUrl + "/api/Map3DObject/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetMapAreaMapObject(_response);
        });
    },[baseUrl, instance])

    const processGetMapAreaMapObject = (response: AxiosResponse): Promise<Map3DObjectDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<Map3DObjectDetailsDto>(<any>null);
    }
    
    const deleteMapObject = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Map3DObject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteMapObject(_response);
        });
    },[baseUrl, instance])

    const processDeleteMapObject = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const updateCesiumSettings = useCallback((newSettings
    : Map3DObjectSettingsUpdateDto
    , objectId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Map3DObject/{objectId}/settings";
        if (objectId === undefined || objectId === null)
            throw new Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUpdateCesiumSettings(_response);
        });
    },[baseUrl, instance])

    const processUpdateCesiumSettings = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            updateFileInfo,
            addMap3DObject,
            getAvailableObjects,
            getMapAreaMapObject,
            deleteMapObject,
            updateCesiumSettings,
        }),
      [        updateFileInfo,
            addMap3DObject,
            getAvailableObjects,
            getMapAreaMapObject,
            deleteMapObject,
            updateCesiumSettings,
    ],
    );
  };

export const useMapAreaApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    
    interface getMapAreasQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getMapAreas = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getMapAreasQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfMapAreaItemDto> => {
        let url_ = baseUrl + "/api/MapArea?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetMapAreas(_response);
        });
    },[baseUrl, instance])

    const processGetMapAreas = (response: AxiosResponse): Promise<PaginatedListOfMapAreaItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfMapAreaItemDto>(<any>null);
    }
    
    const addMapArea = useCallback((mapArea
    : MapAreaCreateDto
    
    ): Promise<void> => {
        let url_ = baseUrl + "/api/MapArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapArea);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddMapArea(_response);
        });
    },[baseUrl, instance])

    const processAddMapArea = (response: AxiosResponse): Promise<void> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<void>(<any>null);
    }
    
    const editMapArea = useCallback((mapArea
    : MapAreaEditDto
    , mapAreaId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/MapArea/{mapAreaId}";
        if (mapAreaId === undefined || mapAreaId === null)
            throw new Error("The parameter 'mapAreaId' must be defined.");
        url_ = url_.replace("{mapAreaId}", encodeURIComponent("" + mapAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapArea);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditMapArea(_response);
        });
    },[baseUrl, instance])

    const processEditMapArea = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteMapArea = useCallback((mapAreaId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/MapArea/{mapAreaId}";
        if (mapAreaId === undefined || mapAreaId === null)
            throw new Error("The parameter 'mapAreaId' must be defined.");
        url_ = url_.replace("{mapAreaId}", encodeURIComponent("" + mapAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteMapArea(_response);
        });
    },[baseUrl, instance])

    const processDeleteMapArea = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            getMapAreas,
            addMapArea,
            editMapArea,
            deleteMapArea,
        }),
      [        getMapAreas,
            addMapArea,
            editMapArea,
            deleteMapArea,
    ],
    );
  };

export const useNauticalWarningApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    
    interface getNauticalWarningsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getNauticalWarnings = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getNauticalWarningsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfNauticalWarningItemDto> => {
        let url_ = baseUrl + "/api/NauticalWarning?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetNauticalWarnings(_response);
        });
    },[baseUrl, instance])

    const processGetNauticalWarnings = (response: AxiosResponse): Promise<PaginatedListOfNauticalWarningItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfNauticalWarningItemDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            getNauticalWarnings,
        }),
      [        getNauticalWarnings,
    ],
    );
  };

export const useOperationFaultApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addOperationFault = useCallback((operationFaultCreate
    : OperationFaultCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationFault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationFaultCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddOperationFault(_response);
        });
    },[baseUrl, instance])

    const processAddOperationFault = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getOperationFaultsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getOperationFaults = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getOperationFaultsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfOperationFaultListDto> => {
        let url_ = baseUrl + "/api/OperationFault?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOperationFaults(_response);
        });
    },[baseUrl, instance])

    const processGetOperationFaults = (response: AxiosResponse): Promise<PaginatedListOfOperationFaultListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfOperationFaultListDto>(<any>null);
    }
    
    const editOperationFault = useCallback((operationFaultEdit
    : OperationFaultEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationFault/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationFaultEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditOperationFault(_response);
        });
    },[baseUrl, instance])

    const processEditOperationFault = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteOperationFault = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationFault/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteOperationFault(_response);
        });
    },[baseUrl, instance])

    const processDeleteOperationFault = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addOperationFault,
            getOperationFaults,
            editOperationFault,
            deleteOperationFault,
        }),
      [        addOperationFault,
            getOperationFaults,
            editOperationFault,
            deleteOperationFault,
    ],
    );
  };

export const useOperationTargetApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addOperationTarget = useCallback((operationTargetCreate
    : OperationTargetCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationTargetCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddOperationTarget(_response);
        });
    },[baseUrl, instance])

    const processAddOperationTarget = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getOperationTargetsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getOperationTargets = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getOperationTargetsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfOperationTargetListDto> => {
        let url_ = baseUrl + "/api/OperationTarget?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOperationTargets(_response);
        });
    },[baseUrl, instance])

    const processGetOperationTargets = (response: AxiosResponse): Promise<PaginatedListOfOperationTargetListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfOperationTargetListDto>(<any>null);
    }
    
    const editOperationTarget = useCallback((operationTargetEdit
    : OperationTargetEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationTarget/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationTargetEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditOperationTarget(_response);
        });
    },[baseUrl, instance])

    const processEditOperationTarget = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteOperationTarget = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationTarget/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteOperationTarget(_response);
        });
    },[baseUrl, instance])

    const processDeleteOperationTarget = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addOperationTarget,
            getOperationTargets,
            editOperationTarget,
            deleteOperationTarget,
        }),
      [        addOperationTarget,
            getOperationTargets,
            editOperationTarget,
            deleteOperationTarget,
    ],
    );
  };

export const useOperationTypeApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addOperationType = useCallback((operationTypeCreate
    : OperationTypeCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationTypeCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddOperationType(_response);
        });
    },[baseUrl, instance])

    const processAddOperationType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getOperationTypesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getOperationTypes = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getOperationTypesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfOperationTypeListDto> => {
        let url_ = baseUrl + "/api/OperationType?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOperationTypes(_response);
        });
    },[baseUrl, instance])

    const processGetOperationTypes = (response: AxiosResponse): Promise<PaginatedListOfOperationTypeListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfOperationTypeListDto>(<any>null);
    }
    
    const editOperationType = useCallback((operationTypeEdit
    : OperationTypeEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationTypeEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditOperationType(_response);
        });
    },[baseUrl, instance])

    const processEditOperationType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteOperationType = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/OperationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteOperationType(_response);
        });
    },[baseUrl, instance])

    const processDeleteOperationType = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addOperationType,
            getOperationTypes,
            editOperationType,
            deleteOperationType,
        }),
      [        addOperationType,
            getOperationTypes,
            editOperationType,
            deleteOperationType,
    ],
    );
  };

export const useOrganizationApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addOrganization = useCallback((o
    : OrganizationCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(o);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddOrganization(_response);
        });
    },[baseUrl, instance])

    const processAddOrganization = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getOrganizationsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getOrganizations = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getOrganizationsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfOrganizationListDto> => {
        let url_ = baseUrl + "/api/Organization?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganizations(_response);
        });
    },[baseUrl, instance])

    const processGetOrganizations = (response: AxiosResponse): Promise<PaginatedListOfOrganizationListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfOrganizationListDto>(<any>null);
    }
    
    const editOrganization = useCallback((o
    : OrganizationEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(o);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditOrganization(_response);
        });
    },[baseUrl, instance])

    const processEditOrganization = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getOrganization = useCallback((id
    : number
    
    ): Promise<OrganizationDetailsDto> => {
        let url_ = baseUrl + "/api/Organization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganization(_response);
        });
    },[baseUrl, instance])

    const processGetOrganization = (response: AxiosResponse): Promise<OrganizationDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<OrganizationDetailsDto>(<any>null);
    }
    
    const deleteOrganization = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteOrganization(_response);
        });
    },[baseUrl, instance])

    const processDeleteOrganization = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const addOrganizationRole = useCallback((o
    : OrganizationRoleCreateDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}/role";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(o);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddOrganizationRole(_response);
        });
    },[baseUrl, instance])

    const processAddOrganizationRole = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getOrganizationRolesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getOrganizationRoles = useCallback((id
    : number
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getOrganizationRolesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfOrganizationRoleListDto> => {
        let url_ = baseUrl + "/api/Organization/{id}/role?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganizationRoles(_response);
        });
    },[baseUrl, instance])

    const processGetOrganizationRoles = (response: AxiosResponse): Promise<PaginatedListOfOrganizationRoleListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfOrganizationRoleListDto>(<any>null);
    }
    
    const editOrganizationRole = useCallback((o
    : OrganizationRoleEditDto
    , id
    : number
    , roleId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}/role/{roleId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(o);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditOrganizationRole(_response);
        });
    },[baseUrl, instance])

    const processEditOrganizationRole = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteOrganizationRole = useCallback((id
    : number
    , roleId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}/role/{roleId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteOrganizationRole(_response);
        });
    },[baseUrl, instance])

    const processDeleteOrganizationRole = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getOrganizationRole = useCallback((id
    : number
    , roleId
    : number
    
    ): Promise<OrganizationRoleDetailsDto> => {
        let url_ = baseUrl + "/api/Organization/{id}/role/{roleId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganizationRole(_response);
        });
    },[baseUrl, instance])

    const processGetOrganizationRole = (response: AxiosResponse): Promise<OrganizationRoleDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<OrganizationRoleDetailsDto>(<any>null);
    }
    
    const toggleRoleNotification = useCallback((organizationId
    : number
    , roleId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{organizationId}/notification/{roleId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processToggleRoleNotification(_response);
        });
    },[baseUrl, instance])

    const processToggleRoleNotification = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const changeUserOrganization = useCallback((id
    : number
    , dto
    : OrganizationUserMoveDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}/user";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processChangeUserOrganization(_response);
        });
    },[baseUrl, instance])

    const processChangeUserOrganization = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getOrganizationUsersQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getOrganizationUsers = useCallback((id
    : number
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getOrganizationUsersQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfUserListDto> => {
        let url_ = baseUrl + "/api/Organization/{id}/user?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganizationUsers(_response);
        });
    },[baseUrl, instance])

    const processGetOrganizationUsers = (response: AxiosResponse): Promise<PaginatedListOfUserListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfUserListDto>(<any>null);
    }
    
    const editOrganizationUser = useCallback((id
    : number
    , userId
    : number
    , dto
    : OrganizationUserEditDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}/user/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditOrganizationUser(_response);
        });
    },[baseUrl, instance])

    const processEditOrganizationUser = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteOrganizationUser = useCallback((id
    : number
    , userId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{id}/user/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteOrganizationUser(_response);
        });
    },[baseUrl, instance])

    const processDeleteOrganizationUser = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getOrganizationPermissions = useCallback((orgId
    : number
    
    ): Promise<PermissionItemDto[]> => {
        let url_ = baseUrl + "/api/Organization/{orgId}/permission";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganizationPermissions(_response);
        });
    },[baseUrl, instance])

    const processGetOrganizationPermissions = (response: AxiosResponse): Promise<PermissionItemDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PermissionItemDto[]>(<any>null);
    }
    
    const setOrganizationPermissions = useCallback((orgId
    : number
    , newPermissions
    : PermissionItemDto[]
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{orgId}/permission";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPermissions);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSetOrganizationPermissions(_response);
        });
    },[baseUrl, instance])

    const processSetOrganizationPermissions = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getOrganizationRolePermissions = useCallback((orgId
    : number
    , orgRoleId
    : number
    
    ): Promise<PermissionItemDto[]> => {
        let url_ = baseUrl + "/api/Organization/{orgId}/role/{orgRoleId}/permission";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (orgRoleId === undefined || orgRoleId === null)
            throw new Error("The parameter 'orgRoleId' must be defined.");
        url_ = url_.replace("{orgRoleId}", encodeURIComponent("" + orgRoleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetOrganizationRolePermissions(_response);
        });
    },[baseUrl, instance])

    const processGetOrganizationRolePermissions = (response: AxiosResponse): Promise<PermissionItemDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PermissionItemDto[]>(<any>null);
    }
    
    const setOrganizationRolePermissions = useCallback((orgId
    : number
    , orgRoleId
    : number
    , newPermissions
    : PermissionItemDto[]
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Organization/{orgId}/role/{orgRoleId}/permission";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (orgRoleId === undefined || orgRoleId === null)
            throw new Error("The parameter 'orgRoleId' must be defined.");
        url_ = url_.replace("{orgRoleId}", encodeURIComponent("" + orgRoleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPermissions);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSetOrganizationRolePermissions(_response);
        });
    },[baseUrl, instance])

    const processSetOrganizationRolePermissions = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addOrganization,
            getOrganizations,
            editOrganization,
            getOrganization,
            deleteOrganization,
            addOrganizationRole,
            getOrganizationRoles,
            editOrganizationRole,
            deleteOrganizationRole,
            getOrganizationRole,
            toggleRoleNotification,
            changeUserOrganization,
            getOrganizationUsers,
            editOrganizationUser,
            deleteOrganizationUser,
            getOrganizationPermissions,
            setOrganizationPermissions,
            getOrganizationRolePermissions,
            setOrganizationRolePermissions,
        }),
      [        addOrganization,
            getOrganizations,
            editOrganization,
            getOrganization,
            deleteOrganization,
            addOrganizationRole,
            getOrganizationRoles,
            editOrganizationRole,
            deleteOrganizationRole,
            getOrganizationRole,
            toggleRoleNotification,
            changeUserOrganization,
            getOrganizationUsers,
            editOrganizationUser,
            deleteOrganizationUser,
            getOrganizationPermissions,
            setOrganizationPermissions,
            getOrganizationRolePermissions,
            setOrganizationRolePermissions,
    ],
    );
  };

export const usePortApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addPort = useCallback((p
    : PortCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(p);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddPort(_response);
        });
    },[baseUrl, instance])

    const processAddPort = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getPortsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getPorts = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getPortsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfPortListDto> => {
        let url_ = baseUrl + "/api/Port?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPorts(_response);
        });
    },[baseUrl, instance])

    const processGetPorts = (response: AxiosResponse): Promise<PaginatedListOfPortListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfPortListDto>(<any>null);
    }
    
    const editPort = useCallback((p
    : PortEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(p);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditPort(_response);
        });
    },[baseUrl, instance])

    const processEditPort = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getPort = useCallback((id
    : number
    
    ): Promise<PortDetailsDto> => {
        let url_ = baseUrl + "/api/Port/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPort(_response);
        });
    },[baseUrl, instance])

    const processGetPort = (response: AxiosResponse): Promise<PortDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PortDetailsDto>(<any>null);
    }
    
    const deletePort = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeletePort(_response);
        });
    },[baseUrl, instance])

    const processDeletePort = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getLocodesQueryParams {
        x?: number | undefined, 
        y?: number | undefined
    }
    
    const getLocodes = useCallback((
    { x
    , y
     }: getLocodesQueryParams={ x: undefined, y: undefined }): Promise<PortLocodeDto[]> => {
        let url_ = baseUrl + "/api/Port/Locode?";
        if (x === null)
            throw new Error("The parameter 'x' cannot be null.");
        else if (x !== undefined)
            url_ += "X=" + encodeURIComponent("" + x) + "&";
        if (y === null)
            throw new Error("The parameter 'y' cannot be null.");
        else if (y !== undefined)
            url_ += "Y=" + encodeURIComponent("" + y) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetLocodes(_response);
        });
    },[baseUrl, instance])

    const processGetLocodes = (response: AxiosResponse): Promise<PortLocodeDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PortLocodeDto[]>(<any>null);
    }
    
    const addPortCallComment = useCallback((portCallId
    : number
    , dto
    : PortCallCommentAddDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/PortCallComment/{portCallId}";
        if (portCallId === undefined || portCallId === null)
            throw new Error("The parameter 'portCallId' must be defined.");
        url_ = url_.replace("{portCallId}", encodeURIComponent("" + portCallId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddPortCallComment(_response);
        });
    },[baseUrl, instance])

    const processAddPortCallComment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editPortCallComment = useCallback((id
    : number
    , dto
    : PortCallCommentEditDto
    , portCallId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/PortCallComment/{portCallId}/edit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (portCallId === undefined || portCallId === null)
            throw new Error("The parameter 'portCallId' must be defined.");
        url_ = url_.replace("{portCallId}", encodeURIComponent("" + portCallId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditPortCallComment(_response);
        });
    },[baseUrl, instance])

    const processEditPortCallComment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deletePortCallComment = useCallback((id
    : number
    , portCallId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/PortCallComment/{portCallId}/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (portCallId === undefined || portCallId === null)
            throw new Error("The parameter 'portCallId' must be defined.");
        url_ = url_.replace("{portCallId}", encodeURIComponent("" + portCallId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeletePortCallComment(_response);
        });
    },[baseUrl, instance])

    const processDeletePortCallComment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const addPortCallV2Comment = useCallback((portCallId
    : number
    , dto
    : PortCallCommentAddDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/PortCallV2Comment/{portCallId}";
        if (portCallId === undefined || portCallId === null)
            throw new Error("The parameter 'portCallId' must be defined.");
        url_ = url_.replace("{portCallId}", encodeURIComponent("" + portCallId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddPortCallV2Comment(_response);
        });
    },[baseUrl, instance])

    const processAddPortCallV2Comment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editPortCallV2Comment = useCallback((id
    : number
    , dto
    : PortCallCommentEditDto
    , portCallId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/PortCallV2Comment/{portCallId}/edit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (portCallId === undefined || portCallId === null)
            throw new Error("The parameter 'portCallId' must be defined.");
        url_ = url_.replace("{portCallId}", encodeURIComponent("" + portCallId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditPortCallV2Comment(_response);
        });
    },[baseUrl, instance])

    const processEditPortCallV2Comment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deletePortCallV2Comment = useCallback((id
    : number
    , portCallId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/PortCallV2Comment/{portCallId}/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (portCallId === undefined || portCallId === null)
            throw new Error("The parameter 'portCallId' must be defined.");
        url_ = url_.replace("{portCallId}", encodeURIComponent("" + portCallId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeletePortCallV2Comment(_response);
        });
    },[baseUrl, instance])

    const processDeletePortCallV2Comment = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getPortCallCommentsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getPortCallComments = useCallback((locode
    : string
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getPortCallCommentsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfPortCallCommentDetailsDto> => {
        let url_ = baseUrl + "/api/Port/PortCallComment/{locode}?";
        if (locode === undefined || locode === null)
            throw new Error("The parameter 'locode' must be defined.");
        url_ = url_.replace("{locode}", encodeURIComponent("" + locode));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortCallComments(_response);
        });
    },[baseUrl, instance])

    const processGetPortCallComments = (response: AxiosResponse): Promise<PaginatedListOfPortCallCommentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfPortCallCommentDetailsDto>(<any>null);
    }
    
    
    interface getPortCallV2CommentsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getPortCallV2Comments = useCallback((locode
    : string
    , 
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getPortCallV2CommentsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfPortCallCommentDetailsDto> => {
        let url_ = baseUrl + "/api/Port/PortCallCommentV2/{locode}?";
        if (locode === undefined || locode === null)
            throw new Error("The parameter 'locode' must be defined.");
        url_ = url_.replace("{locode}", encodeURIComponent("" + locode));
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortCallV2Comments(_response);
        });
    },[baseUrl, instance])

    const processGetPortCallV2Comments = (response: AxiosResponse): Promise<PaginatedListOfPortCallCommentDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfPortCallCommentDetailsDto>(<any>null);
    }
    
    const editVesselContact = useCallback((newInfo
    : string
    , mmsi
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Port/vesselContact/{mmsi}";
        if (mmsi === undefined || mmsi === null)
            throw new Error("The parameter 'mmsi' must be defined.");
        url_ = url_.replace("{mmsi}", encodeURIComponent("" + mmsi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newInfo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditVesselContact(_response);
        });
    },[baseUrl, instance])

    const processEditVesselContact = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addPort,
            getPorts,
            editPort,
            getPort,
            deletePort,
            getLocodes,
            addPortCallComment,
            editPortCallComment,
            deletePortCallComment,
            addPortCallV2Comment,
            editPortCallV2Comment,
            deletePortCallV2Comment,
            getPortCallComments,
            getPortCallV2Comments,
            editVesselContact,
        }),
      [        addPort,
            getPorts,
            editPort,
            getPort,
            deletePort,
            getLocodes,
            addPortCallComment,
            editPortCallComment,
            deletePortCallComment,
            addPortCallV2Comment,
            editPortCallV2Comment,
            deletePortCallV2Comment,
            getPortCallComments,
            getPortCallV2Comments,
            editVesselContact,
    ],
    );
  };

export const usePortServiceApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addPortService = useCallback((portServiceToCreate
    : PortServiceCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/PortService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(portServiceToCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddPortService(_response);
        });
    },[baseUrl, instance])

    const processAddPortService = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getPortServicesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined, 
        id?: number | undefined
    }
    
    const getPortServices = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
    , id
     }: getPortServicesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined, id: undefined }): Promise<PaginatedListOfPortServiceItemDto> => {
        let url_ = baseUrl + "/api/PortService?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortServices(_response);
        });
    },[baseUrl, instance])

    const processGetPortServices = (response: AxiosResponse): Promise<PaginatedListOfPortServiceItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfPortServiceItemDto>(<any>null);
    }
    
    const editPortService = useCallback((portServiceToEdit
    : PortServiceUpdateDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/PortService/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(portServiceToEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditPortService(_response);
        });
    },[baseUrl, instance])

    const processEditPortService = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getPortService = useCallback((id
    : number
    
    ): Promise<PortServiceItemDto> => {
        let url_ = baseUrl + "/api/PortService/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortService(_response);
        });
    },[baseUrl, instance])

    const processGetPortService = (response: AxiosResponse): Promise<PortServiceItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PortServiceItemDto>(<any>null);
    }
    
    const deletePortService = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/PortService/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeletePortService(_response);
        });
    },[baseUrl, instance])

    const processDeletePortService = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getAllPortServicesQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getAllPortServices = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getAllPortServicesQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfPortServiceItemDto> => {
        let url_ = baseUrl + "/api/PortService/all?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAllPortServices(_response);
        });
    },[baseUrl, instance])

    const processGetAllPortServices = (response: AxiosResponse): Promise<PaginatedListOfPortServiceItemDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfPortServiceItemDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            addPortService,
            getPortServices,
            editPortService,
            getPortService,
            deletePortService,
            getAllPortServices,
        }),
      [        addPortService,
            getPortServices,
            editPortService,
            getPortService,
            deletePortService,
            getAllPortServices,
    ],
    );
  };

export const useProjectApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addProject = useCallback((projectAdd
    : ProjectAddDto
    
    ): Promise<ProjectListDto> => {
        let url_ = baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectAdd);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddProject(_response);
        });
    },[baseUrl, instance])

    const processAddProject = (response: AxiosResponse): Promise<ProjectListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ProjectListDto>(<any>null);
    }
    
    
    interface getProjectsQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getProjects = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getProjectsQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfProjectListDto> => {
        let url_ = baseUrl + "/api/Project?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetProjects(_response);
        });
    },[baseUrl, instance])

    const processGetProjects = (response: AxiosResponse): Promise<PaginatedListOfProjectListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfProjectListDto>(<any>null);
    }
    
    const editProject = useCallback((id
    : number
    , projectEdit
    : ProjectEditDto
    
    ): Promise<ProjectListDto> => {
        let url_ = baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditProject(_response);
        });
    },[baseUrl, instance])

    const processEditProject = (response: AxiosResponse): Promise<ProjectListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ProjectListDto>(<any>null);
    }
    
    const removeProject = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemoveProject(_response);
        });
    },[baseUrl, instance])

    const processRemoveProject = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getProjectQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getProject = useCallback((projectId
    : number
    , 
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getProjectQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<ProjectListDto> => {
        let url_ = baseUrl + "/api/Project/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetProject(_response);
        });
    },[baseUrl, instance])

    const processGetProject = (response: AxiosResponse): Promise<ProjectListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ProjectListDto>(<any>null);
    }
    
    const addPOI = useCallback((poiDto
    : PTOPProjectPOIDto
    , projectId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/poi";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(poiDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddPOI(_response);
        });
    },[baseUrl, instance])

    const processAddPOI = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getPOIs = useCallback((projectId
    : number
    
    ): Promise<PTOPProjectPOIDto[]> => {
        let url_ = baseUrl + "/api/Project/{projectId}/poi";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPOIs(_response);
        });
    },[baseUrl, instance])

    const processGetPOIs = (response: AxiosResponse): Promise<PTOPProjectPOIDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PTOPProjectPOIDto[]>(<any>null);
    }
    
    const removePOI = useCallback((projectId
    : number
    , poiId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/poi/{poiId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (poiId === undefined || poiId === null)
            throw new Error("The parameter 'poiId' must be defined.");
        url_ = url_.replace("{poiId}", encodeURIComponent("" + poiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemovePOI(_response);
        });
    },[baseUrl, instance])

    const processRemovePOI = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getFeaturesQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getFeatures = useCallback((projectId
    : number
    , 
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getFeaturesQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PTOPFeatureListDto[]> => {
        let url_ = baseUrl + "/api/Project/{projectId}/features?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFeatures(_response);
        });
    },[baseUrl, instance])

    const processGetFeatures = (response: AxiosResponse): Promise<PTOPFeatureListDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PTOPFeatureListDto[]>(<any>null);
    }
    
    const link = useCallback((linkDto
    : ProjectLinkDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/Link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(linkDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processLink(_response);
        });
    },[baseUrl, instance])

    const processLink = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getWPRTemplateList = useCallback((
    ): Promise<WPRListDto[]> => {
        let url_ = baseUrl + "/api/Project/wpr/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWPRTemplateList(_response);
        });
    },[baseUrl, instance])

    const processGetWPRTemplateList = (response: AxiosResponse): Promise<WPRListDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<WPRListDto[]>(<any>null);
    }
    
    const getWPRList = useCallback((projectId
    : number
    
    ): Promise<WPRListDto[]> => {
        let url_ = baseUrl + "/api/Project/{projectId}/wpr";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWPRList(_response);
        });
    },[baseUrl, instance])

    const processGetWPRList = (response: AxiosResponse): Promise<WPRListDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<WPRListDto[]>(<any>null);
    }
    
    const uploadWPR = useCallback((projectId
    : number
    , file
    ?: FileParameter
     | null | undefined
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/wpr";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUploadWPR(_response);
        });
    },[baseUrl, instance])

    const processUploadWPR = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getLatestWPR = useCallback((projectId
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/wpr/latest";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetLatestWPR(_response);
        });
    },[baseUrl, instance])

    const processGetLatestWPR = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    const generateWPR = useCallback((createWPR
    : WPRCreateDto
    , projectId
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/wpr/generate";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createWPR);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGenerateWPR(_response);
        });
    },[baseUrl, instance])

    const processGenerateWPR = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getGeoJson = useCallback((projectId
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/progress";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetGeoJson(_response);
        });
    },[baseUrl, instance])

    const processGetGeoJson = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    const updateProject = useCallback((projectId
    : number
    , files
    ?: FileParameter[]
     | null | undefined, coordinateSystemId
    ?: number
     | null | undefined
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/progress";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (coordinateSystemId !== null && coordinateSystemId !== undefined)
            content_.append("CoordinateSystemId", coordinateSystemId.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUpdateProject(_response);
        });
    },[baseUrl, instance])

    const processUpdateProject = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getGeoJson2 = useCallback((projectId
    : number
    
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/plan";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetGeoJson2(_response);
        });
    },[baseUrl, instance])

    const processGetGeoJson2 = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    const updateProject2 = useCallback((projectId
    : number
    , files
    ?: FileParameter[]
     | null | undefined, coordinateSystemId
    ?: number
     | null | undefined
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Project/{projectId}/plan";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (coordinateSystemId !== null && coordinateSystemId !== undefined)
            content_.append("CoordinateSystemId", coordinateSystemId.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUpdateProject2(_response);
        });
    },[baseUrl, instance])

    const processUpdateProject2 = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addProject,
            getProjects,
            editProject,
            removeProject,
            getProject,
            addPOI,
            getPOIs,
            removePOI,
            getFeatures,
            link,
            getWPRTemplateList,
            getWPRList,
            uploadWPR,
            getLatestWPR,
            generateWPR,
            getGeoJson,
            updateProject,
            getGeoJson2,
            updateProject2,
        }),
      [        addProject,
            getProjects,
            editProject,
            removeProject,
            getProject,
            addPOI,
            getPOIs,
            removePOI,
            getFeatures,
            link,
            getWPRTemplateList,
            getWPRList,
            uploadWPR,
            getLatestWPR,
            generateWPR,
            getGeoJson,
            updateProject,
            getGeoJson2,
            updateProject2,
    ],
    );
  };

export const useReimariApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    
    interface getAtonUnitsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getAtonUnits = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getAtonUnitsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfAtonUnit> => {
        let url_ = baseUrl + "/api/Reimari/AtonUnit?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAtonUnits(_response);
        });
    },[baseUrl, instance])

    const processGetAtonUnits = (response: AxiosResponse): Promise<PaginatedListOfAtonUnit> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfAtonUnit>(<any>null);
    }
    
    const getAtonUnit = useCallback((atonNumber
    : number
    
    ): Promise<AtonUnitDetails> => {
        let url_ = baseUrl + "/api/Reimari/AtonUnit/{atonNumber}";
        if (atonNumber === undefined || atonNumber === null)
            throw new Error("The parameter 'atonNumber' must be defined.");
        url_ = url_.replace("{atonNumber}", encodeURIComponent("" + atonNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAtonUnit(_response);
        });
    },[baseUrl, instance])

    const processGetAtonUnit = (response: AxiosResponse): Promise<AtonUnitDetails> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<AtonUnitDetails>(<any>null);
    }
    
    const getSdGroups = useCallback((
    ): Promise<SdGroup[]> => {
        let url_ = baseUrl + "/api/Reimari/SdGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSdGroups(_response);
        });
    },[baseUrl, instance])

    const processGetSdGroups = (response: AxiosResponse): Promise<SdGroup[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SdGroup[]>(<any>null);
    }
  
    return useMemo(
      () => ({
            getAtonUnits,
            getAtonUnit,
            getSdGroups,
        }),
      [        getAtonUnits,
            getAtonUnit,
            getSdGroups,
    ],
    );
  };

export const useSafetyDeviceSearchApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const getSdDropdownInfos = useCallback((
    ): Promise<SdDropdownDto> => {
        let url_ = baseUrl + "/api/SafetyDeviceSearch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSdDropdownInfos(_response);
        });
    },[baseUrl, instance])

    const processGetSdDropdownInfos = (response: AxiosResponse): Promise<SdDropdownDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SdDropdownDto>(<any>null);
    }
    
    const getSdActionDropdownInfos = useCallback((dto
    : ActionDropdownSelections
    
    ): Promise<SdActionDropdownDto> => {
        let url_ = baseUrl + "/api/SafetyDeviceSearch/ActionInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSdActionDropdownInfos(_response);
        });
    },[baseUrl, instance])

    const processGetSdActionDropdownInfos = (response: AxiosResponse): Promise<SdActionDropdownDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SdActionDropdownDto>(<any>null);
    }
    
    const sdSearch = useCallback((dto
    : SdSearchDto
    
    ): Promise<AtonUnit[]> => {
        let url_ = baseUrl + "/api/SafetyDeviceSearch/Sd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSdSearch(_response);
        });
    },[baseUrl, instance])

    const processSdSearch = (response: AxiosResponse): Promise<AtonUnit[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<AtonUnit[]>(<any>null);
    }
    
    const actionSearch = useCallback((dto
    : ActionSearchDto
    
    ): Promise<Action[]> => {
        let url_ = baseUrl + "/api/SafetyDeviceSearch/Action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processActionSearch(_response);
        });
    },[baseUrl, instance])

    const processActionSearch = (response: AxiosResponse): Promise<Action[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<Action[]>(<any>null);
    }
    
    const faultSearch = useCallback((query
    : FaultSearchDto
    
    ): Promise<Fault[]> => {
        let url_ = baseUrl + "/api/SafetyDeviceSearch/Fault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processFaultSearch(_response);
        });
    },[baseUrl, instance])

    const processFaultSearch = (response: AxiosResponse): Promise<Fault[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<Fault[]>(<any>null);
    }
  
    return useMemo(
      () => ({
            getSdDropdownInfos,
            getSdActionDropdownInfos,
            sdSearch,
            actionSearch,
            faultSearch,
        }),
      [        getSdDropdownInfos,
            getSdActionDropdownInfos,
            sdSearch,
            actionSearch,
            faultSearch,
    ],
    );
  };

export const useSeaDaticsApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const getAtonUnit = useCallback((atonNumber
    : number
    
    ): Promise<InSeaFullAtonDetails> => {
        let url_ = baseUrl + "/api/SeaDatics/AtonUnit/{atonNumber}";
        if (atonNumber === undefined || atonNumber === null)
            throw new Error("The parameter 'atonNumber' must be defined.");
        url_ = url_.replace("{atonNumber}", encodeURIComponent("" + atonNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAtonUnit(_response);
        });
    },[baseUrl, instance])

    const processGetAtonUnit = (response: AxiosResponse): Promise<InSeaFullAtonDetails> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = JSON.parse(resultData502, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result502);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<InSeaFullAtonDetails>(<any>null);
    }
  
    return useMemo(
      () => ({
            getAtonUnit,
        }),
      [        getAtonUnit,
    ],
    );
  };

export const useSeaSurveyApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addSeaSurvey = useCallback((seaSurveyToCreate
    : SeaSurveyCreateDto
    
    ): Promise<ReturnNodeDto> => {
        let url_ = baseUrl + "/api/SeaSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seaSurveyToCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddSeaSurvey(_response);
        });
    },[baseUrl, instance])

    const processAddSeaSurvey = (response: AxiosResponse): Promise<ReturnNodeDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto>(<any>null);
    }
    
    
    interface getSeaSurveysQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getSeaSurveys = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getSeaSurveysQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfSeaSurveyListDto> => {
        let url_ = baseUrl + "/api/SeaSurvey?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSeaSurveys(_response);
        });
    },[baseUrl, instance])

    const processGetSeaSurveys = (response: AxiosResponse): Promise<PaginatedListOfSeaSurveyListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfSeaSurveyListDto>(<any>null);
    }
    
    const editSeaSurvey = useCallback((seaSurveyToEdit
    : SeaSurveyEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SeaSurvey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seaSurveyToEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditSeaSurvey(_response);
        });
    },[baseUrl, instance])

    const processEditSeaSurvey = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getSeaSurvey = useCallback((id
    : number
    
    ): Promise<SeaSurveyDetailsDto> => {
        let url_ = baseUrl + "/api/SeaSurvey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSeaSurvey(_response);
        });
    },[baseUrl, instance])

    const processGetSeaSurvey = (response: AxiosResponse): Promise<SeaSurveyDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SeaSurveyDetailsDto>(<any>null);
    }
    
    const deleteSeaSurvey = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SeaSurvey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteSeaSurvey(_response);
        });
    },[baseUrl, instance])

    const processDeleteSeaSurvey = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getSeaSurveyFiles = useCallback((id
    : number
    
    ): Promise<ReturnNodeDto[]> => {
        let url_ = baseUrl + "/api/SeaSurvey/{id}/files";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSeaSurveyFiles(_response);
        });
    },[baseUrl, instance])

    const processGetSeaSurveyFiles = (response: AxiosResponse): Promise<ReturnNodeDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ReturnNodeDto[]>(<any>null);
    }
    
    const updateFileCesiumSettings = useCallback((newSettings
    : FileInformationSettingsUpdateDto
    , surveyId
    : number
    , fileId
    : number
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/SeaSurvey/{surveyId}/settings/{fileId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUpdateFileCesiumSettings(_response);
        });
    },[baseUrl, instance])

    const processUpdateFileCesiumSettings = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
    
    const updateSurveyOffset = useCallback((newOffset
    : SeaSurveyHeightOffsetDto
    , surveyId
    : number
    
    ): Promise<string> => {
        let url_ = baseUrl + "/api/SeaSurvey/{surveyId}/offset";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newOffset);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processUpdateSurveyOffset(_response);
        });
    },[baseUrl, instance])

    const processUpdateSurveyOffset = (response: AxiosResponse): Promise<string> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<string>(<any>null);
    }
  
    return useMemo(
      () => ({
            addSeaSurvey,
            getSeaSurveys,
            editSeaSurvey,
            getSeaSurvey,
            deleteSeaSurvey,
            getSeaSurveyFiles,
            updateFileCesiumSettings,
            updateSurveyOffset,
        }),
      [        addSeaSurvey,
            getSeaSurveys,
            editSeaSurvey,
            getSeaSurvey,
            deleteSeaSurvey,
            getSeaSurveyFiles,
            updateFileCesiumSettings,
            updateSurveyOffset,
    ],
    );
  };

export const useSecurityClassificationApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addSecurityClassification = useCallback((securityClassificationCreate
    : SecurityClassificationCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SecurityClassification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityClassificationCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddSecurityClassification(_response);
        });
    },[baseUrl, instance])

    const processAddSecurityClassification = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getSecurityClassificationsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getSecurityClassifications = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getSecurityClassificationsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfSecurityClassificationListDto> => {
        let url_ = baseUrl + "/api/SecurityClassification?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSecurityClassifications(_response);
        });
    },[baseUrl, instance])

    const processGetSecurityClassifications = (response: AxiosResponse): Promise<PaginatedListOfSecurityClassificationListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfSecurityClassificationListDto>(<any>null);
    }
    
    const editSecurityClassification = useCallback((securityClassificationEdit
    : SecurityClassificationEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SecurityClassification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityClassificationEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditSecurityClassification(_response);
        });
    },[baseUrl, instance])

    const processEditSecurityClassification = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteSecurityClassification = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SecurityClassification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteSecurityClassification(_response);
        });
    },[baseUrl, instance])

    const processDeleteSecurityClassification = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addSecurityClassification,
            getSecurityClassifications,
            editSecurityClassification,
            deleteSecurityClassification,
        }),
      [        addSecurityClassification,
            getSecurityClassifications,
            editSecurityClassification,
            deleteSecurityClassification,
    ],
    );
  };

export const useSurveyMethodApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const addSurveyMethod = useCallback((surveyMethodCreate
    : SurveyMethodCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SurveyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyMethodCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processAddSurveyMethod(_response);
        });
    },[baseUrl, instance])

    const processAddSurveyMethod = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getSurveyMethodsQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getSurveyMethods = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getSurveyMethodsQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfSurveyMethodListDto> => {
        let url_ = baseUrl + "/api/SurveyMethod?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSurveyMethods(_response);
        });
    },[baseUrl, instance])

    const processGetSurveyMethods = (response: AxiosResponse): Promise<PaginatedListOfSurveyMethodListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfSurveyMethodListDto>(<any>null);
    }
    
    const editSurveyMethod = useCallback((surveyMethodEdit
    : SurveyMethodEditDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SurveyMethod/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyMethodEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditSurveyMethod(_response);
        });
    },[baseUrl, instance])

    const processEditSurveyMethod = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteSurveyMethod = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/SurveyMethod/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteSurveyMethod(_response);
        });
    },[baseUrl, instance])

    const processDeleteSurveyMethod = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            addSurveyMethod,
            getSurveyMethods,
            editSurveyMethod,
            deleteSurveyMethod,
        }),
      [        addSurveyMethod,
            getSurveyMethods,
            editSurveyMethod,
            deleteSurveyMethod,
    ],
    );
  };

export const useThirdPartyApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const getIce = useCallback((
    ): Promise<FileResponse> => {
        let url_ = baseUrl + "/api/ThirdParty/Ice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetIce(_response);
        });
    },[baseUrl, instance])

    const processGetIce = (response: AxiosResponse): Promise<FileResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
    
    
    interface getWeatherQueryParams {
        storedquery_id?: string | null | undefined, 
        bbox?: string | null | undefined, 
        parameters?: string | null | undefined, 
        timeStep?: string | null | undefined, 
        crs?: string | null | undefined, 
        place?: string | null | undefined
    }
    
    const getWeather = useCallback((
    { storedquery_id
    , bbox
    , parameters
    , timeStep
    , crs
    , place
     }: getWeatherQueryParams={ storedquery_id: undefined, bbox: undefined, parameters: undefined, timeStep: undefined, crs: undefined, place: undefined }): Promise<WindDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/Weather?";
        if (storedquery_id !== undefined && storedquery_id !== null)
            url_ += "Storedquery_id=" + encodeURIComponent("" + storedquery_id) + "&";
        if (bbox !== undefined && bbox !== null)
            url_ += "Bbox=" + encodeURIComponent("" + bbox) + "&";
        if (parameters !== undefined && parameters !== null)
            url_ += "Parameters=" + encodeURIComponent("" + parameters) + "&";
        if (timeStep !== undefined && timeStep !== null)
            url_ += "TimeStep=" + encodeURIComponent("" + timeStep) + "&";
        if (crs !== undefined && crs !== null)
            url_ += "Crs=" + encodeURIComponent("" + crs) + "&";
        if (place !== undefined && place !== null)
            url_ += "Place=" + encodeURIComponent("" + place) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWeather(_response);
        });
    },[baseUrl, instance])

    const processGetWeather = (response: AxiosResponse): Promise<WindDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<WindDto[]>(<any>null);
    }
    
    
    interface getWaveQueryParams {
        storedquery_id?: string | null | undefined, 
        bbox?: string | null | undefined, 
        parameters?: string | null | undefined, 
        timeStep?: string | null | undefined, 
        crs?: string | null | undefined, 
        place?: string | null | undefined
    }
    
    const getWave = useCallback((
    { storedquery_id
    , bbox
    , parameters
    , timeStep
    , crs
    , place
     }: getWaveQueryParams={ storedquery_id: undefined, bbox: undefined, parameters: undefined, timeStep: undefined, crs: undefined, place: undefined }): Promise<WaveDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/Wave?";
        if (storedquery_id !== undefined && storedquery_id !== null)
            url_ += "Storedquery_id=" + encodeURIComponent("" + storedquery_id) + "&";
        if (bbox !== undefined && bbox !== null)
            url_ += "Bbox=" + encodeURIComponent("" + bbox) + "&";
        if (parameters !== undefined && parameters !== null)
            url_ += "Parameters=" + encodeURIComponent("" + parameters) + "&";
        if (timeStep !== undefined && timeStep !== null)
            url_ += "TimeStep=" + encodeURIComponent("" + timeStep) + "&";
        if (crs !== undefined && crs !== null)
            url_ += "Crs=" + encodeURIComponent("" + crs) + "&";
        if (place !== undefined && place !== null)
            url_ += "Place=" + encodeURIComponent("" + place) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWave(_response);
        });
    },[baseUrl, instance])

    const processGetWave = (response: AxiosResponse): Promise<WaveDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<WaveDto[]>(<any>null);
    }
    
    
    interface getSeaQueryParams {
        storedquery_id?: string | null | undefined, 
        bbox?: string | null | undefined, 
        parameters?: string | null | undefined, 
        timeStep?: string | null | undefined, 
        crs?: string | null | undefined, 
        place?: string | null | undefined
    }
    
    const getSea = useCallback((
    { storedquery_id
    , bbox
    , parameters
    , timeStep
    , crs
    , place
     }: getSeaQueryParams={ storedquery_id: undefined, bbox: undefined, parameters: undefined, timeStep: undefined, crs: undefined, place: undefined }): Promise<SeaDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/Sea?";
        if (storedquery_id !== undefined && storedquery_id !== null)
            url_ += "Storedquery_id=" + encodeURIComponent("" + storedquery_id) + "&";
        if (bbox !== undefined && bbox !== null)
            url_ += "Bbox=" + encodeURIComponent("" + bbox) + "&";
        if (parameters !== undefined && parameters !== null)
            url_ += "Parameters=" + encodeURIComponent("" + parameters) + "&";
        if (timeStep !== undefined && timeStep !== null)
            url_ += "TimeStep=" + encodeURIComponent("" + timeStep) + "&";
        if (crs !== undefined && crs !== null)
            url_ += "Crs=" + encodeURIComponent("" + crs) + "&";
        if (place !== undefined && place !== null)
            url_ += "Place=" + encodeURIComponent("" + place) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSea(_response);
        });
    },[baseUrl, instance])

    const processGetSea = (response: AxiosResponse): Promise<SeaDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SeaDto[]>(<any>null);
    }
    
    
    interface getWeatherHistoryQueryParams {
        station?: number | null | undefined
    }
    
    const getWeatherHistory = useCallback((
    { station
     }: getWeatherHistoryQueryParams={ station: undefined }): Promise<WindDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/WeatherHistory?";
        if (station !== undefined && station !== null)
            url_ += "station=" + encodeURIComponent("" + station) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWeatherHistory(_response);
        });
    },[baseUrl, instance])

    const processGetWeatherHistory = (response: AxiosResponse): Promise<WindDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<WindDto[]>(<any>null);
    }
    
    
    interface getWaveHistoryQueryParams {
        station?: number | null | undefined
    }
    
    const getWaveHistory = useCallback((
    { station
     }: getWaveHistoryQueryParams={ station: undefined }): Promise<WaveDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/WaveHistory?";
        if (station !== undefined && station !== null)
            url_ += "station=" + encodeURIComponent("" + station) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetWaveHistory(_response);
        });
    },[baseUrl, instance])

    const processGetWaveHistory = (response: AxiosResponse): Promise<WaveDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<WaveDto[]>(<any>null);
    }
    
    
    interface getSeaHistoryQueryParams {
        station?: number | null | undefined
    }
    
    const getSeaHistory = useCallback((
    { station
     }: getSeaHistoryQueryParams={ station: undefined }): Promise<SeaDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/SeaHistory?";
        if (station !== undefined && station !== null)
            url_ += "station=" + encodeURIComponent("" + station) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSeaHistory(_response);
        });
    },[baseUrl, instance])

    const processGetSeaHistory = (response: AxiosResponse): Promise<SeaDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<SeaDto[]>(<any>null);
    }
    
    const getAISItems = useCallback((
    ): Promise<AISVesselDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/ais";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAISItems(_response);
        });
    },[baseUrl, instance])

    const processGetAISItems = (response: AxiosResponse): Promise<AISVesselDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<AISVesselDto[]>(<any>null);
    }
    
    
    interface getAISHistoriesQueryParams {
        startTime?: Date | null | undefined, 
        endTime?: Date | null | undefined
    }
    
    const getAISHistories = useCallback((mmsi
    : number
    , 
    { startTime
    , endTime
     }: getAISHistoriesQueryParams={ startTime: undefined, endTime: undefined }): Promise<VesselLocationHistoryDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/ais/LocationHistory/{Mmsi}?";
        if (mmsi === undefined || mmsi === null)
            throw new Error("The parameter 'mmsi' must be defined.");
        url_ = url_.replace("{Mmsi}", encodeURIComponent("" + mmsi));
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAISHistories(_response);
        });
    },[baseUrl, instance])

    const processGetAISHistories = (response: AxiosResponse): Promise<VesselLocationHistoryDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<VesselLocationHistoryDto[]>(<any>null);
    }
    
    
    interface getAISHistories2QueryParams {
        startTime?: Date | null | undefined, 
        endTime?: Date | null | undefined
    }
    
    const getAISHistories2 = useCallback((fleetId
    : number
    , 
    { startTime
    , endTime
     }: getAISHistories2QueryParams={ startTime: undefined, endTime: undefined }): Promise<VesselLocationHistoryDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/ais/LocationHistory/fleet/{FleetId}?";
        if (fleetId === undefined || fleetId === null)
            throw new Error("The parameter 'fleetId' must be defined.");
        url_ = url_.replace("{FleetId}", encodeURIComponent("" + fleetId));
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAISHistories2(_response);
        });
    },[baseUrl, instance])

    const processGetAISHistories2 = (response: AxiosResponse): Promise<VesselLocationHistoryDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<VesselLocationHistoryDto[]>(<any>null);
    }
    
    
    interface getFilteredAISItemsQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getFilteredAISItems = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getFilteredAISItemsQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfAISVesselDto> => {
        let url_ = baseUrl + "/api/ThirdParty/ais/filter?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetFilteredAISItems(_response);
        });
    },[baseUrl, instance])

    const processGetFilteredAISItems = (response: AxiosResponse): Promise<PaginatedListOfAISVesselDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfAISVesselDto>(<any>null);
    }
    
    
    interface getPortCallsQueryParams {
        startTime?: Date | null | undefined, 
        endTime?: Date | null | undefined
    }
    
    const getPortCalls = useCallback((locode
    : string
    , 
    { startTime
    , endTime
     }: getPortCallsQueryParams={ startTime: undefined, endTime: undefined }): Promise<PortCallDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/portCalls/{Locode}?";
        if (locode === undefined || locode === null)
            throw new Error("The parameter 'locode' must be defined.");
        url_ = url_.replace("{Locode}", encodeURIComponent("" + locode));
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortCalls(_response);
        });
    },[baseUrl, instance])

    const processGetPortCalls = (response: AxiosResponse): Promise<PortCallDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PortCallDto[]>(<any>null);
    }
    
    
    interface getPortCallsV2QueryParams {
        startTime?: Date | null | undefined, 
        endTime?: Date | null | undefined
    }
    
    const getPortCallsV2 = useCallback((locode
    : string
    , 
    { startTime
    , endTime
     }: getPortCallsV2QueryParams={ startTime: undefined, endTime: undefined }): Promise<PortCallV2Dto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/portCalls/V2/{Locode}?";
        if (locode === undefined || locode === null)
            throw new Error("The parameter 'locode' must be defined.");
        url_ = url_.replace("{Locode}", encodeURIComponent("" + locode));
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortCallsV2(_response);
        });
    },[baseUrl, instance])

    const processGetPortCallsV2 = (response: AxiosResponse): Promise<PortCallV2Dto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PortCallV2Dto[]>(<any>null);
    }
    
    
    interface getPortCallsCombinedQueryParams {
        startTime?: Date | null | undefined, 
        endTime?: Date | null | undefined
    }
    
    const getPortCallsCombined = useCallback((locode
    : string
    , 
    { startTime
    , endTime
     }: getPortCallsCombinedQueryParams={ startTime: undefined, endTime: undefined }): Promise<PortCallCombinedDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/portCalls/{Locode}/combined?";
        if (locode === undefined || locode === null)
            throw new Error("The parameter 'locode' must be defined.");
        url_ = url_.replace("{Locode}", encodeURIComponent("" + locode));
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetPortCallsCombined(_response);
        });
    },[baseUrl, instance])

    const processGetPortCallsCombined = (response: AxiosResponse): Promise<PortCallCombinedDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PortCallCombinedDto[]>(<any>null);
    }
    
    
    interface getLuodeQueryParams {
        startTime?: Date | null | undefined, 
        endTime?: Date | null | undefined
    }
    
    const getLuode = useCallback((
    { startTime
    , endTime
     }: getLuodeQueryParams={ startTime: undefined, endTime: undefined }): Promise<LuodeDto[]> => {
        let url_ = baseUrl + "/api/ThirdParty/Luode?";
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetLuode(_response);
        });
    },[baseUrl, instance])

    const processGetLuode = (response: AxiosResponse): Promise<LuodeDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<LuodeDto[]>(<any>null);
    }
  
    return useMemo(
      () => ({
            getIce,
            getWeather,
            getWave,
            getSea,
            getWeatherHistory,
            getWaveHistory,
            getSeaHistory,
            getAISItems,
            getAISHistories,
            getAISHistories2,
            getFilteredAISItems,
            getPortCalls,
            getPortCallsV2,
            getPortCallsCombined,
            getLuode,
        }),
      [        getIce,
            getWeather,
            getWave,
            getSea,
            getWeatherHistory,
            getWaveHistory,
            getSeaHistory,
            getAISItems,
            getAISHistories,
            getAISHistories2,
            getFilteredAISItems,
            getPortCalls,
            getPortCallsV2,
            getPortCallsCombined,
            getLuode,
    ],
    );
  };

export const useTrackerApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const editTracker = useCallback((trackerEdit
    : TrackerEditDto
    , trackerManufacturer
    : TrackerManufacturer
    , deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/Tracker/{trackerManufacturer}/{deviceId}";
        if (trackerManufacturer === undefined || trackerManufacturer === null)
            throw new Error("The parameter 'trackerManufacturer' must be defined.");
        url_ = url_.replace("{trackerManufacturer}", encodeURIComponent("" + trackerManufacturer));
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackerEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditTracker(_response);
        });
    },[baseUrl, instance])

    const processEditTracker = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getElisaTrackersQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getElisaTrackers = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getElisaTrackersQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfElisaDeviceDto> => {
        let url_ = baseUrl + "/api/Tracker/elisa?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetElisaTrackers(_response);
        });
    },[baseUrl, instance])

    const processGetElisaTrackers = (response: AxiosResponse): Promise<PaginatedListOfElisaDeviceDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfElisaDeviceDto>(<any>null);
    }
    
    
    interface getTaivalTrackersQueryParams {
        filters?: SingleFilterValue[] | null | undefined, 
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getTaivalTrackers = useCallback((
    { filters
    , page
    , pageSize
    , sortField
    , descending
    , search
     }: getTaivalTrackersQueryParams={ filters: undefined, page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfTaivalDeviceDto> => {
        let url_ = baseUrl + "/api/Tracker/taival?";
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetTaivalTrackers(_response);
        });
    },[baseUrl, instance])

    const processGetTaivalTrackers = (response: AxiosResponse): Promise<PaginatedListOfTaivalDeviceDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfTaivalDeviceDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            editTracker,
            getElisaTrackers,
            getTaivalTrackers,
        }),
      [        editTracker,
            getElisaTrackers,
            getTaivalTrackers,
    ],
    );
  };

export const useTrafficBuoyApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const getRouterKey = useCallback((deviceId
    : string
    
    ): Promise<RouterKeyDto> => {
        let url_ = baseUrl + "/api/TrafficBuoy/{deviceId}/key";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetRouterKey(_response);
        });
    },[baseUrl, instance])

    const processGetRouterKey = (response: AxiosResponse): Promise<RouterKeyDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<RouterKeyDto>(<any>null);
    }
    
    
    interface getRoutersQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getRouters = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getRoutersQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfRouterListDto> => {
        let url_ = baseUrl + "/api/TrafficBuoy?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetRouters(_response);
        });
    },[baseUrl, instance])

    const processGetRouters = (response: AxiosResponse): Promise<PaginatedListOfRouterListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfRouterListDto>(<any>null);
    }
    
    const createRouter = useCallback((routerCreate
    : RouterCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/TrafficBuoy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(routerCreate);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processCreateRouter(_response);
        });
    },[baseUrl, instance])

    const processCreateRouter = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editRouter = useCallback((routerEdit
    : RouterEditDto
    , deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/TrafficBuoy/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(routerEdit);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditRouter(_response);
        });
    },[baseUrl, instance])

    const processEditRouter = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const deleteRouter = useCallback((deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/TrafficBuoy/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processDeleteRouter(_response);
        });
    },[baseUrl, instance])

    const processDeleteRouter = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const buoyControlOn = useCallback((deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/TrafficBuoy/{deviceId}/control/on";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processBuoyControlOn(_response);
        });
    },[baseUrl, instance])

    const processBuoyControlOn = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const buoyControlOff = useCallback((deviceId
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/TrafficBuoy/{deviceId}/control/off";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processBuoyControlOff(_response);
        });
    },[baseUrl, instance])

    const processBuoyControlOff = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
  
    return useMemo(
      () => ({
            getRouterKey,
            getRouters,
            createRouter,
            editRouter,
            deleteRouter,
            buoyControlOn,
            buoyControlOff,
        }),
      [        getRouterKey,
            getRouters,
            createRouter,
            editRouter,
            deleteRouter,
            buoyControlOn,
            buoyControlOff,
    ],
    );
  };

export const useUserApi = (API_URL?: string) => {
    const baseUrl = API_URL ?? API_BASE_URL;
    const instance = useAxios();
    const { t } = useTranslation();
        
    const inviteUser = useCallback((u
    : UserCreateDto
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(u);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processInviteUser(_response);
        });
    },[baseUrl, instance])

    const processInviteUser = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    
    interface getUsersQueryParams {
        page?: number | null | undefined, 
        pageSize?: number | null | undefined, 
        sortField?: string | null | undefined, 
        descending?: boolean | undefined, 
        search?: string | null | undefined
    }
    
    const getUsers = useCallback((
    { page
    , pageSize
    , sortField
    , descending
    , search
     }: getUsersQueryParams={ page: undefined, pageSize: undefined, sortField: undefined, descending: undefined, search: undefined }): Promise<PaginatedListOfUserListDto> => {
        let url_ = baseUrl + "/api/User?";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetUsers(_response);
        });
    },[baseUrl, instance])

    const processGetUsers = (response: AxiosResponse): Promise<PaginatedListOfUserListDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PaginatedListOfUserListDto>(<any>null);
    }
    
    const getUser = useCallback((id
    : number
    
    ): Promise<UserDetailsDto> => {
        let url_ = baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetUser(_response);
        });
    },[baseUrl, instance])

    const processGetUser = (response: AxiosResponse): Promise<UserDetailsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<UserDetailsDto>(<any>null);
    }
    
    const removeUser = useCallback((id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processRemoveUser(_response);
        });
    },[baseUrl, instance])

    const processRemoveUser = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const editSubscription = useCallback((subscriptionDto
    : VesselAlarmSubscriptionDto
    , id
    : number
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/User/{id}/subscribe/vessel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processEditSubscription(_response);
        });
    },[baseUrl, instance])

    const processEditSubscription = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const getSubscription = useCallback((id
    : number
    
    ): Promise<VesselAlarmSubscriptionDto> => {
        let url_ = baseUrl + "/api/User/{id}/subscribe/vessel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetSubscription(_response);
        });
    },[baseUrl, instance])

    const processGetSubscription = (response: AxiosResponse): Promise<VesselAlarmSubscriptionDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<VesselAlarmSubscriptionDto>(<any>null);
    }
    
    const login = useCallback((
    ): Promise<UserLoginDto> => {
        let url_ = baseUrl + "/api/User/Login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processLogin(_response);
        });
    },[baseUrl, instance])

    const processLogin = (response: AxiosResponse): Promise<UserLoginDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = JSON.parse(resultData503, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<UserLoginDto>(<any>null);
    }
    
    const getUserPermissions = useCallback((userId
    : number
    
    ): Promise<PermissionItemDto[]> => {
        let url_ = baseUrl + "/api/User/{userId}/permission";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetUserPermissions(_response);
        });
    },[baseUrl, instance])

    const processGetUserPermissions = (response: AxiosResponse): Promise<PermissionItemDto[]> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<PermissionItemDto[]>(<any>null);
    }
    
    const setUserPermissions = useCallback((userId
    : number
    , newPermissions
    : PermissionItemDto[]
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/User/{userId}/permission";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPermissions);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSetUserPermissions(_response);
        });
    },[baseUrl, instance])

    const processSetUserPermissions = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const setUserPhone = useCallback((number
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/User/setmobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(number);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSetUserPhone(_response);
        });
    },[baseUrl, instance])

    const processSetUserPhone = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const setUserEmail = useCallback((email
    : string
    
    ): Promise<ApiResponse> => {
        let url_ = baseUrl + "/api/User/setemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processSetUserEmail(_response);
        });
    },[baseUrl, instance])

    const processSetUserEmail = (response: AxiosResponse): Promise<ApiResponse> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }
    
    const toggleAlarmMute = useCallback((
    ): Promise<boolean> => {
        let url_ = baseUrl + "/api/User/togglealarmmute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processToggleAlarmMute(_response);
        });
    },[baseUrl, instance])

    const processToggleAlarmMute = (response: AxiosResponse): Promise<boolean> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<boolean>(<any>null);
    }
    
    const toggleArrivalMute = useCallback((
    ): Promise<boolean> => {
        let url_ = baseUrl + "/api/User/togglearrivalmute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processToggleArrivalMute(_response);
        });
    },[baseUrl, instance])

    const processToggleArrivalMute = (response: AxiosResponse): Promise<boolean> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<boolean>(<any>null);
    }
    
    const getAllUserAccesses = useCallback((userId
    : number
    
    ): Promise<UserMaterializedPermissionsDto> => {
        let url_ = baseUrl + "/api/User/{userId}/materializedpermission";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetAllUserAccesses(_response);
        });
    },[baseUrl, instance])

    const processGetAllUserAccesses = (response: AxiosResponse): Promise<UserMaterializedPermissionsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<UserMaterializedPermissionsDto>(<any>null);
    }
    
    const getCurrentUserAccesses = useCallback((
    ): Promise<UserMaterializedPermissionsDto> => {
        let url_ = baseUrl + "/api/User/materializedpermission";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetCurrentUserAccesses(_response);
        });
    },[baseUrl, instance])

    const processGetCurrentUserAccesses = (response: AxiosResponse): Promise<UserMaterializedPermissionsDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<UserMaterializedPermissionsDto>(<any>null);
    }
    
    const getGraphUser = useCallback((
    ): Promise<GraphUserDto> => {
        let url_ = baseUrl + "/api/User/graph";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return processGetGraphUser(_response);
        });
    },[baseUrl, instance])

    const processGetGraphUser = (response: AxiosResponse): Promise<GraphUserDto> => {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, (_, value) => jsonParseReviver(value));
            return result200;
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, (_, value) => jsonParseReviver(value));
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            let result;
            try {
                result = JSON.parse(_responseText, (_, value) => jsonParseReviver(value));
            } catch (ex) {
                return throwException(t("general:unexpected-error"), status, _responseText, _headers);
            }
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, result);
        }
        return Promise.resolve<GraphUserDto>(<any>null);
    }
  
    return useMemo(
      () => ({
            inviteUser,
            getUsers,
            getUser,
            removeUser,
            editSubscription,
            getSubscription,
            login,
            getUserPermissions,
            setUserPermissions,
            setUserPhone,
            setUserEmail,
            toggleAlarmMute,
            toggleArrivalMute,
            getAllUserAccesses,
            getCurrentUserAccesses,
            getGraphUser,
        }),
      [        inviteUser,
            getUsers,
            getUser,
            removeUser,
            editSubscription,
            getSubscription,
            login,
            getUserPermissions,
            setUserPermissions,
            setUserPhone,
            setUserEmail,
            toggleAlarmMute,
            toggleArrivalMute,
            getAllUserAccesses,
            getCurrentUserAccesses,
            getGraphUser,
    ],
    );
  };

export interface AccessItemDto {
    accessId: AccessEnum;
    mapAreaRequired: boolean;
}

export enum AccessEnum {
    PortRead = 1,
    PortUpdate = 2,
    FairwayRead = 3,
    FairwayUpdate = 4,
    DamRead = 5,
    DamUpdate = 6,
    FerryUpdate = 7,
    FerryRead = 8,
    CanalRead = 9,
    CanalUpdate = 10,
    MapAreaRead = 11,
    MapAreaUpdate = 12,
    SafetyDeviceRead = 13,
    SafetyDeviceUpdate = 14,
    OrganizationFileRead = 15,
    OrganizationFileUpdate = 16,
    CreateUsers = 17,
    OtherOrganizationsUpdate = 18,
    MapAreaCreate = 19,
    EventRead = 20,
    EventUpdate = 21,
    FleetRead = 22,
    FleetUpdate = 23,
    SeaSurveyRead = 24,
    SeaSurveyUpdate = 25,
    MapAreaFileRead = 26,
    MapAreaFileUpdate = 27,
    DesignMaterialRead = 28,
    DesignMaterialUpdate = 29,
    Map3DObjectRead = 30,
    Map3DObjectUpdate = 31,
    TrafficLightBuoyRead = 32,
    TrafficLightBuoyUpdate = 33,
    RemoteTrackingDevicesRead = 34,
    RemoteTrackingDevicesUpdate = 35,
    EquipmentManagementRead = 36,
    AISModemRead = 37,
    AISModemUpdate = 38,
    CameraRead = 39,
    CameraUpdate = 40,
    CameraStream = 41,
    ProjectRead = 42,
    EquipmentManagementUpdate = 43,
    ProjectUpdate = 44,
    BookingRead = 45,
    BookingUpdate = 46,
}

export interface ApiResponse {
    resultKey?: string | undefined;
    modelErrors?: ModelError[][] | undefined;
}

export interface ModelError {
    exception?: Exception | undefined;
    errorMessage: string;
}

export interface Exception {
    Message: string;
    InnerException?: Exception | undefined;
    Source?: string | undefined;
    StackTrace?: string | undefined;
}

export interface VesselRouterCreateDto {
    deviceId: string;
    name: string;
    mmsi?: number | undefined;
}

export interface VesselRouterEditDto {
    name?: string | undefined;
    mmsi?: number | undefined;
}

export interface PaginatedListOfVesselRouterListDto {
    results: VesselRouterListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface VesselRouterListDto {
    deviceId: string;
    state?: string | undefined;
    stateUpdateDate: Date;
    name?: string | undefined;
    uptime: number;
    rssi: number;
    ipAddress?: string | undefined;
    routerTelemetryUpdateDate: Date;
    cameras?: CameraItemDto[] | undefined;
    vessel?: AISVesselDto | undefined;
    vesselTelemetry?: VesselTelemetryDto | undefined;
}

export interface CameraItemDto {
    id: number;
    name: string;
    description: string;
    streamUrl: string;
    aisModemDeviceId?: string | undefined;
    aisModemName?: string | undefined;
    vesselName?: string | undefined;
    record: boolean;
}

export interface AISVesselDto {
    mmsi: number;
    callSign?: string | undefined;
    destination?: string | undefined;
    name?: string | undefined;
    referencePointA: number;
    referencePointB: number;
    referencePointC: number;
    referencePointD: number;
    shipType: number;
    timestampExternal: number;
    length: number;
    breadth: number;
    height: number;
    longitude: number;
    latitude: number;
    altitude?: number | undefined;
    cog: number;
    heading?: number | undefined;
    rot: number;
    sog: number;
    navStat: number;
    posAcc: boolean;
    raim: boolean;
    eta: number;
    imo: number;
    contactInfos?: VesselContactDetailsDto[] | undefined;
    trackerInfo?: VesselTrackerInfoDto | undefined;
    router?: VesselRouterListDto | undefined;
}

export interface VesselContactDetailsDto {
    infoId: number;
    infoField?: string | undefined;
}

export interface VesselTrackerInfoDto {
    itemId: number;
    name?: string | undefined;
    equipmentType?: EquipmentTypeListDto | undefined;
}

export interface EquipmentTypeListDto {
    id: number;
    name?: string | undefined;
}

export interface VesselTelemetryDto {
    activeAlarms?: VesselAlarmType[] | undefined;
    vesselTelemetryUpdateDate: Date;
    plcDateTime: Date;
    shorePower: boolean;
    recordingTime: number;
}

export enum VesselAlarmType {
    Fire = 0,
    BilgeWater = 1,
    LowIndoorTemperature = 2,
    FireAlarmFault = 10,
    BilgeWaterAlarmFault = 11,
    LowIndoorTemperatureAlarmFault = 12,
    MotionDetected = 30,
    PLCBattery = 31,
    ExteriorDoorOpen = 32,
    RouterTelemetryOutdated = 33,
    VesselTelemetryOutdated = 34,
}

export interface SingleFilterValue {
    field?: string | undefined;
    value?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export interface ArrivalZoneCreateDto {
    name: string;
    description?: string | undefined;
    portId: number;
    location: Coordinate[];
    rolesToNotify: number[];
    active: boolean;
}

export interface Coordinate {
    x: number;
    y: number;
}

export interface ArrivalZoneEditDto {
    name: string;
    description?: string | undefined;
    location: Coordinate[];
    rolesToNotify: number[];
    active: boolean;
}

export interface PaginatedListOfArrivalZoneListDto {
    results: ArrivalZoneListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface ArrivalZoneListDto {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    location?: Coordinate[] | undefined;
    active: boolean;
    port?: PortDetailsDto | undefined;
}

export interface PortDetailsDto {
    id: number;
    name: string;
    description?: string | undefined;
    locode: PortLocodeDto;
    points: Coordinate[];
    mapAreas?: MapAreaItemDto[] | undefined;
}

export interface PortLocodeDto {
    id: number;
    locode?: string | undefined;
    portAreaName?: string | undefined;
    portAreaCode?: string | undefined;
    coordinate?: Coordinate | undefined;
}

export interface MapAreaItemDto {
    mapAreaId: number;
    name: string;
    mapAreaType: MapAreaTypeEnum;
    projectID?: string | undefined;
    projectName?: string | undefined;
    reimariTSdGroupSDGROUP_IDs: number[];
    link?: ProjectLinkDto | undefined;
}

export enum MapAreaTypeEnum {
    MaintenanceContract = 1,
    BuoyContract = 2,
    Project = 3,
}

export interface ProjectLinkDto {
    projectId?: number | undefined;
    mapAreaId?: number | undefined;
}

export interface ArrivalZoneDetailsDto {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    port?: PortDetailsDto | undefined;
    location?: Coordinate[] | undefined;
    organizationId: number;
    rolesToNotify?: number[] | undefined;
    active: boolean;
}

export interface BerthCreateDto {
    name?: string | undefined;
    description?: string | undefined;
    capacity: number;
    water: boolean;
    garbage: boolean;
    power: boolean;
    portId: number;
    points: Coordinate[];
}

export interface BerthEditDto {
    name?: string | undefined;
    description?: string | undefined;
    capacity: number;
    water: boolean;
    garbage: boolean;
    power: boolean;
    points: Coordinate[];
}

export interface PaginatedListOfBerthListDto {
    results: BerthListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface BerthListDto {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    capacity: number;
    water: boolean;
    garbage: boolean;
    power: boolean;
    points: Coordinate[];
    port?: PortListDto | undefined;
}

export interface PortListDto {
    id: number;
    name: string;
    description?: string | undefined;
    locode: PortLocodeDto;
    points: Coordinate[];
}

export interface BerthDetailsDto {
    id: number;
    portId: number;
    name?: string | undefined;
    description?: string | undefined;
    capacity: number;
    water: boolean;
    garbage: boolean;
    power: boolean;
    points?: Coordinate[] | undefined;
}

export interface BerthEventCreateDto {
    name?: string | undefined;
    description?: string | undefined;
    startTimestamp: Date;
    endTimestamp: Date;
}

export interface BerthEventEditDto {
    name?: string | undefined;
    description?: string | undefined;
    startTimestamp: Date;
    endTimestamp: Date;
}

export interface PaginatedListOfBerthEventListDto {
    results: BerthEventListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface BerthEventListDto {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    startTimestamp: Date;
    endTimestamp: Date;
}

export interface BerthEventDetailsDto {
    name?: string | undefined;
    description?: string | undefined;
    startTimestamp: Date;
    endTimestamp: Date;
}

export interface BerthOrderCreateDto {
    startTimestamp: Date;
    endTimestamp: Date;
    cordMen: boolean;
    water: boolean;
    power: boolean;
    garbage: boolean;
    vesselId: number;
}

export interface BerthOrderEditDto {
    startTimestamp: Date;
    endTimestamp: Date;
    cordMen: boolean;
    water: boolean;
    power: boolean;
    garbage: boolean;
    vesselId: number;
    berthId: number;
}

export interface PaginatedListOfBerthOrderListDto {
    results: BerthOrderListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface BerthOrderListDto {
    id: number;
    startTimestamp: Date;
    endTimestamp: Date;
    cordMen: boolean;
    water: boolean;
    power: boolean;
    garbage: boolean;
    vesselId: number;
    berthId: number;
    vessel?: AISVesselDto | undefined;
}

export interface BerthOrderDetailsDto {
    startTimestamp: Date;
    endTimestamp: Date;
    cordMen: boolean;
    water: boolean;
    power: boolean;
    garbage: boolean;
    vesselId: number;
    berthId: number;
}

export interface PaginatedListOfBookingDetailsDto {
    results: BookingDetailsDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface BookingDetailsDto {
    id: number;
    contactName?: string | undefined;
    startDate: Date;
    endDate: Date;
    user?: UserListDto | undefined;
    equipmentItem?: EquipmentDetailsDto | undefined;
    project?: ProjectListDto | undefined;
}

export interface UserListDto {
    id: number;
    name?: string | undefined;
    email?: string | undefined;
    organizationId: number;
    organization?: OrganizationListDto | undefined;
    organizationRoles?: OrganizationRoleListDto[] | undefined;
}

export interface OrganizationListDto {
    id: number;
    name: string;
    address?: string | undefined;
}

export interface OrganizationRoleListDto {
    id: number;
    roleName?: string | undefined;
    baseAccess: boolean;
    allowNotifications: boolean;
}

export interface EquipmentDetailsDto {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    equipmentType?: EquipmentTypeListDto | undefined;
    tracker?: EquipmentTrackerInfoDto | undefined;
    vehicleItem?: VehicleListDto | undefined;
    waterCraftItem?: WaterCraftListDto | undefined;
    workEquipmentItem?: WorkEquipmentListDto | undefined;
}

export interface EquipmentTrackerInfoDto {
    itemId: number;
    name?: string | undefined;
    equipmentType?: EquipmentTypeListDto | undefined;
    elisaDeviceId?: string | undefined;
    taivalDeviceId?: string | undefined;
    mmsi?: number | undefined;
    latitude: number;
    longitude: number;
    altitude: number;
    locationTimestamp: Date;
}

export interface VehicleListDto {
    id: number;
    itemId: number;
    licencePlate?: string | undefined;
}

export interface WaterCraftListDto {
    id: number;
    itemId: number;
}

export interface WorkEquipmentListDto {
    id: number;
    itemId: number;
}

export interface ProjectListDto {
    id: number;
    projectId?: string | undefined;
    name?: string | undefined;
    clientName?: string | undefined;
    progress: number;
    link?: ProjectLinkDto | undefined;
    processingFiles: boolean;
}

export interface BookingAddDto {
    contactName?: string | undefined;
    startDate: Date;
    endDate: Date;
    userId: number;
    equipmentItemId: number;
    projectId: number;
}

export interface BookingEditDto {
    id: number;
    contactName?: string | undefined;
    startDate: Date;
    endDate: Date;
    userId: number;
    equipmentItemId: number;
    projectId: number;
}

export interface PaginatedListOfCameraClipItemDto {
    results: CameraClipItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface CameraClipItemDto {
    id: number;
    name: string;
    description: string;
    startTime: Date;
    endTime: Date;
    expirationTime: Date;
    cameraId?: number | undefined;
    cameraName?: string | undefined;
}

export interface CameraEditClipDto {
    name: string;
    description: string;
    expirationTime: Date;
}

export interface PaginatedListOfCameraItemDto {
    results: CameraItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface CameraCreateDto {
    name: string;
    description: string;
    streamUrl: string;
    aisModemDeviceId?: string | undefined;
    record: boolean;
}

export interface CameraEditDto {
    name: string;
    description: string;
    streamUrl: string;
    aisModemId?: string | undefined;
    record: boolean;
}

export interface CameraTimesItemDto {
    startInclusive: Date;
    endExclusive: Date;
}

export interface CameraSaveClipDto {
    name: string;
    description: string;
    startTime: Date;
    endTime: Date;
    expirationTime: Date;
}

export interface ComparisonLevelCreateDto {
    name: string;
}

export interface ComparisonLevelEditDto {
    name: string;
}

export interface PaginatedListOfComparisonLevelListDto {
    results: ComparisonLevelListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface ComparisonLevelListDto {
    id: number;
    name: string;
}

export interface CoordinateSystemCreateDto {
    name: string;
    description?: string | undefined;
}

export interface CoordinateSystemEditDto {
    name: string;
    description?: string | undefined;
}

export interface PaginatedListOfCoordinateSystemListDto {
    results: CoordinateSystemListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface CoordinateSystemListDto {
    id: number;
    name: string;
    description?: string | undefined;
}

export interface DamCreateDto {
    name: string;
    description?: string | undefined;
    active: boolean;
    location: Coordinate;
    mapAreaIds?: number[] | undefined;
    maintainerOrganizationId: number;
}

export interface DamEditDto {
    name: string;
    description?: string | undefined;
    active: boolean;
    location: Coordinate;
    mapAreaIds?: number[] | undefined;
    maintainerOrganizationId: number;
}

export interface PaginatedListOfDamListDto {
    results: DamListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface DamListDto {
    id: number;
    name: string;
    description?: string | undefined;
    active: boolean;
    location: Coordinate;
    maintainerOrganization?: OrganizationListDto | undefined;
    damOperations?: DamOperationListDto[] | undefined;
}

export interface DamOperationListDto {
    id: number;
    name: string;
    description?: string | undefined;
    dam: DamListDto;
    startTime: Date;
    completedTime?: Date | undefined;
    operationTarget?: OperationTargetListDto | undefined;
    operationType?: OperationTypeListDto | undefined;
    operationFault?: OperationFaultListDto | undefined;
    operators?: UserListDto[] | undefined;
}

export interface OperationTargetListDto {
    id: number;
    name: string;
}

export interface OperationTypeListDto {
    id: number;
    name: string;
}

export interface OperationFaultListDto {
    id: number;
    name: string;
}

export interface DamDetailsDto {
    id: number;
    name: string;
    description?: string | undefined;
    active: boolean;
    location: Coordinate;
    maintainerOrganization?: OrganizationListDto | undefined;
    mapAreas?: MapAreaItemDto[] | undefined;
    damOperations?: DamOperationListDto[] | undefined;
}

export interface DamOperationCreateDto {
    name: string;
    description?: string | undefined;
    startTime: Date;
    completedTime?: Date | undefined;
    operationTargetId?: number | undefined;
    operationTypeId?: number | undefined;
    operationFaultId?: number | undefined;
    operatorIds?: number[] | undefined;
}

export interface DamOperationEditDto {
    name: string;
    description?: string | undefined;
    startTime: Date;
    completedTime?: Date | undefined;
    operationTargetId?: number | undefined;
    operationTypeId?: number | undefined;
    operationFaultId?: number | undefined;
    operatorIds?: number[] | undefined;
}

export interface PaginatedListOfDamOperationListDto {
    results: DamOperationListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface DamOperationDetailsDto {
    id: number;
    name: string;
    description?: string | undefined;
    dam: DamListDto;
    startTime: Date;
    completedTime?: Date | undefined;
    operationTarget?: OperationTargetListDto | undefined;
    operationType?: OperationTypeListDto | undefined;
    operationFault?: OperationFaultListDto | undefined;
    operators?: UserListDto[] | undefined;
}

export interface ReturnNodeDto {
    id: number;
    name?: string | undefined;
    isFolder: boolean;
    fileType?: string | undefined;
    fileExtension?: string | undefined;
    dataPath?: string | undefined;
    programManaged: boolean;
    parentId?: number | undefined;
    childNodes?: ReturnNodeDto[] | undefined;
    bytes: number;
    fullName?: string | undefined;
    queuedFile?: QueuedFileDto | undefined;
    information?: FileInformationDto | undefined;
    reserved: boolean;
    parentReserved: boolean;
}

export interface QueuedFileDto {
    retryCount: number;
    fileType?: string | undefined;
    projection?: string | undefined;
    stateId: FileStateEnum;
    state?: FileState | undefined;
    edited: boolean;
    processStepId: ProcessStepEnum;
    processStep?: ProcessStep | undefined;
    error?: string | undefined;
    pointCount: number;
    executionTime?: string | undefined;
    estimatedRunTimeMs: number;
    startTime?: Date | undefined;
}

export enum FileStateEnum {
    WaitingToProcess = 1,
    Done = 2,
    Processing = 3,
    Error = 4,
    Skipped = 5,
}

export interface FileState {
    id: FileStateEnum;
    name: string;
}

export enum ProcessStepEnum {
    NotStarted = 0,
    Starting = 1,
    DownloadingFile = 2,
    LazProcessStarting = 101,
    LasProcessStarting = 102,
    ReadingPointCount = 103,
    ReProjecting = 104,
    Tiling = 105,
    ConvertingTiles = 106,
    Zipping = 107,
    UploadingTiledFile = 108,
    CalculatingConvexHull = 109,
    ReadingPointCloudInfo = 110,
    BagProcessStarting = 201,
    ReadingBagElevation = 202,
    ReadingBagUncertainty = 203,
    ReadingBandInfo = 204,
    UploadingTif = 205,
    BagCompleted = 206,
    FauConversionStarting = 301,
    ReadingFau = 302,
    DwgProcessStarting = 401,
    ReadingDwg = 402,
    WritingJson = 403,
    UploadingJson = 404,
    MergeStarting = 501,
    DownloadingMergeFiles = 502,
    WritingFileList = 503,
    Merging = 504,
    UploadingMerged = 505,
    MergeComplete = 506,
    CreatingMergeMetadata = 507,
    MergeFinished = 508,
    Idle = 1000,
}

export interface ProcessStep {
    id: ProcessStepEnum;
    name: string;
}

export interface FileInformationDto {
    maxX: number;
    maxXCarto: number;
    maxY: number;
    maxYCarto: number;
    maxZ: number;
    minX: number;
    minXCarto: number;
    minY: number;
    minYCarto: number;
    minZ: number;
    extentCenterXCarto: number;
    extentCenterYCarto: number;
    hasIntensity: boolean;
    hasRGB: boolean;
    elevationSettings?: string | undefined;
    intensitySettings?: string | undefined;
    pointSizeSettings?: string | undefined;
    attenuationSettings?: string | undefined;
    colorSettings?: string | undefined;
    staticColor?: string | undefined;
    coloringType?: string | undefined;
}

export interface DesignMaterialUpdateDto {
    mapAreaId: number;
    description?: string | undefined;
    comparisonLevelId?: number | undefined;
    coordinateSystemId: number;
    createTimestamp?: Date | undefined;
    uploadTimestamp?: Date | undefined;
    revisionNumber?: number | undefined;
    revisionTimestamp?: Date | undefined;
    revisionDescription?: string | undefined;
    designer?: string | undefined;
    fileIds?: number[] | undefined;
}

export interface PaginatedListOfDesignMaterialItemDto {
    results: DesignMaterialItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface DesignMaterialItemDto {
    id: number;
    mapArea?: MapAreaItemDto | undefined;
    description?: string | undefined;
    comparisonLevel?: ComparisonLevelListDto | undefined;
    coordinateSystem?: CoordinateSystemListDto | undefined;
    createTimestamp?: Date | undefined;
    uploadTimestamp?: Date | undefined;
    revisionNumber?: number | undefined;
    revisionTimestamp?: Date | undefined;
    revisionDescription?: string | undefined;
    designer?: string | undefined;
    fileFolderId: number;
    files?: ReturnNodeDto[] | undefined;
}

export interface PaginatedListOfEquipmentDetailsDto {
    results: EquipmentDetailsDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface EquipmentAddDto {
    name?: string | undefined;
    description?: string | undefined;
    equipmentTypeId: number;
    vehicleItem?: VehicleAddDto | undefined;
    waterCraftItem?: WaterCraftAddDto | undefined;
    workEquipmentItem?: WorkEquipmentAddDto | undefined;
}

export interface VehicleAddDto {
    licencePlate?: string | undefined;
}

export interface WaterCraftAddDto {
}

export interface WorkEquipmentAddDto {
}

export interface EquipmentEditDto {
    name?: string | undefined;
    description?: string | undefined;
    equipmentTypeId: number;
    vehicleItem?: VehicleAddDto | undefined;
    waterCraftItem?: WaterCraftAddDto | undefined;
    workEquipmentItem?: WorkEquipmentAddDto | undefined;
}

export interface EquipmentTypeAddDto {
    name?: string | undefined;
}

export interface EquipmentTypeEditDto {
    name?: string | undefined;
}

export interface EquipmentTrackerLinkDto {
    id: number;
    trackerType?: TrackerManufacturer | undefined;
    trackerDeviceId?: string | undefined;
    mmsi?: number | undefined;
}

export enum TrackerManufacturer {
    Elisa = 0,
    Taival = 1,
}

export interface EventCreateDto {
    name: string;
    description?: string | undefined;
    location: Coordinate;
    equipment?: string | undefined;
    startTimestamp: Date;
    endTimestamp: Date;
    eventTypeId: number;
    mapAreaId?: number | undefined;
}

export interface EventEditDto {
    name: string;
    description?: string | undefined;
    location: Coordinate;
    equipment?: string | undefined;
    startTimestamp: Date;
    endTimestamp: Date;
    eventTypeId: number;
    mapAreaId?: number | undefined;
}

export interface PaginatedListOfEventListDto {
    results: EventListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface EventListDto {
    id: number;
    name: string;
    description: string;
    location: Coordinate;
    equipment: string;
    startTimestamp: Date;
    endTimestamp: Date;
    eventType?: EventTypeListDto | undefined;
    mapAreaId?: number | undefined;
}

export interface EventTypeListDto {
    id: number;
    name: string;
}

export interface EventDetailsDto {
    id: number;
    name: string;
    description: string;
    location: Coordinate;
    equipment: string;
    startTimestamp: Date;
    endTimestamp: Date;
    eventType?: EventTypeListDto | undefined;
    mapAreaId?: number | undefined;
}

export interface EventTypeCreateDto {
    name: string;
}

export interface EventTypeEditDto {
    name: string;
}

export interface PaginatedListOfEventTypeListDto {
    results: EventTypeListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface ExternalApiKeyCreateDto {
    grantedRoleId: number;
    name?: string | undefined;
}

export interface PaginatedListOfExternalApiKeyListDto {
    results: ExternalApiKeyListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface ExternalApiKeyListDto {
    id: number;
    key?: string | undefined;
    name?: string | undefined;
    grantedRole?: OrganizationRoleListDto | undefined;
    creator?: UserListDto | undefined;
}

export interface PaginatedListOfAtonUnit {
    results: AtonUnit[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface AtonUnit {
    atonNumber: number;
    name: string;
    hasLighting?: boolean | undefined;
    subType: string;
    state?: string | undefined;
    stateNumber?: number | undefined;
    mainFairwayId?: number | undefined;
    owner: string;
    type: string;
    navigationType: string;
    structureType?: string | undefined;
    structure?: string | undefined;
    functionalState: string;
    facadeLighting?: boolean | undefined;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
    measuredLocation?: Coordinate | undefined;
    installationLocation?: Coordinate | undefined;
    vatuLocation?: Coordinate | undefined;
    activeFaultCount: number;
    seaDaticsRemoteMonitoring: boolean;
    groups?: string[] | undefined;
}

export interface SdGroup {
    id: number;
    name: string;
    memo: string;
}

export interface AtonUnitDetails {
    atonUnit: AtonUnit;
    components: AtonUnitComponent[];
    faults: Fault[];
    actions: Action[];
}

export interface AtonUnitComponent {
    inEffectStartDate?: Date | undefined;
    inEffectEndDate?: Date | undefined;
    serialNumber: string;
    memo: string;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
    temporary: boolean;
    component: Component;
}

export interface Component {
    name: string;
    memo: string;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
    inEffectStartDate?: Date | undefined;
    inEffectEndDate?: Date | undefined;
    class: ComponentClass;
}

export interface ComponentClass {
    name: string;
    memo: string;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
}

export interface Fault {
    type?: string | undefined;
    state?: string | undefined;
    atonUnitNonfunctional: boolean;
    observationTimestamp?: Date | undefined;
    entryTimestamp?: Date | undefined;
    fixedTimestamp?: Date | undefined;
    observerName: string;
    contact: string;
    memo: string;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
    atonUnit?: AtonUnit | undefined;
}

export interface Action {
    timestamp?: Date | undefined;
    target: string;
    type: string;
    state: string;
    plannedDate?: Date | undefined;
    plannedDuration?: string | undefined;
    responsiblePerson: string;
    personAmount: number;
    durationMinutes: number;
    customerName: string;
    memo: string;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
    group?: string | undefined;
    extraWork: boolean;
    anchoring?: ActionAnchoring | undefined;
    installation?: ActionInstallation | undefined;
    position?: ActionPosition | undefined;
    sector?: ActionSector | undefined;
    atonUnit?: AtonUnit | undefined;
}

export interface ActionAnchoring {
    buoyCondition?: string | undefined;
    chainCondition?: string | undefined;
    anchoringCondition?: string | undefined;
    fasteningTopCondition?: string | undefined;
    fasteningBottomCondition?: string | undefined;
    description: string;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
}

export interface ActionInstallation {
    installationLocation: Coordinate;
    vatuDifference: number;
    vatuDifferenceDegrees: number;
    depth: number;
    perr: number;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
}

export interface ActionPosition {
    location: Coordinate;
    vatuDifference: number;
    vatuDifferenceDegrees: number;
    vatuDifferenceToInstallation: number;
    vatuDifferenceToInstallationDegrees: number;
    depth: number;
    perr: number;
    createTimestamp?: Date | undefined;
    updateTimestamp?: Date | undefined;
}

export interface ActionSector {
    degree: number;
    color1: string;
    color2: string;
    lightNumber: number;
    measuredMeanDegrees: number;
    measuredMeanDistanceMetre: number;
    measuredMeanDeviationDegrees: number;
    perrMean: number;
    updateTimestamp?: Date | undefined;
}

export interface FairwayEditDto {
    name?: string | undefined;
    description?: string | undefined;
}

export interface PaginatedListOfFairwayListDto {
    results: FairwayListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface FairwayListDto {
    id: number;
    name: string;
    description?: string | undefined;
    location: Coordinate[][];
    vaylavirastoId?: string | undefined;
    fairwayId: number;
    nameFin?: string | undefined;
    nameSwe?: string | undefined;
    fairwayState: FairwayStateEnum;
    fairwayType?: FairwayTypeEnum | undefined;
    lighting: LightingEnum;
    seaArea: SeaAreaEnum;
    draught1?: number | undefined;
    draught2?: number | undefined;
    draught3?: number | undefined;
    startDescription?: string | undefined;
    endDescription?: string | undefined;
    registrationNumber?: string | undefined;
    confirmationDate?: string | undefined;
    fairwayClass?: string | undefined;
    publicationDate: Date;
}

export enum FairwayStateEnum {
    Vahvistettu = 1,
    Aihio = 2,
    MuutoksenAlainen = 3,
    Muutosaihio = 4,
    PoistonAlainen = 5,
    Poistettu = 6,
}

export enum FairwayTypeEnum {
    Meriväylä = 1,
    Sisävesiväylä = 2,
}

export enum LightingEnum {
    Tuntematon = 0,
    Valaistu = 1,
    Valaisematon = 2,
}

export enum SeaAreaEnum {
    Tuntematon = 0,
    Perämeri = 1,
    Selkämeri = 2,
    Ahvenanmeri = 3,
    Saaristomeri = 4,
    Suomenlahti = 5,
    Itämeri = 6,
    SaimaanJärvialue = 7,
    PäijänteenJärvialue = 8,
    KokemäenjoenVesistö = 9,
    Oulujärvi = 10,
    SotkamonJärvet = 11,
    KuhmonJärvet = 12,
    KuusamonJärvet = 13,
    Kiantajärvi = 14,
    Simojärvi = 15,
    LokkaPorttipahta = 16,
    Kemijärvi = 17,
    Inarinjärvi = 18,
    Nitsijärvi = 19,
    Miekkojärvi = 20,
    Tornionjoki = 21,
    Ähtärinjärvi = 22,
    Lappajärvi = 23,
    Pyhäjärvi = 24,
    Lohjanjärvi = 25,
}

export interface FairwayDetailsDto {
    id: number;
    name: string;
    description?: string | undefined;
    location: Coordinate[][];
    vaylavirastoId?: string | undefined;
    fairwayId: number;
    nameFin?: string | undefined;
    nameSwe?: string | undefined;
    fairwayState: FairwayStateEnum;
    fairwayType?: FairwayTypeEnum | undefined;
    lighting: LightingEnum;
    seaArea: SeaAreaEnum;
    draught1?: number | undefined;
    draught2?: number | undefined;
    draught3?: number | undefined;
    startDescription?: string | undefined;
    endDescription?: string | undefined;
    registrationNumber?: string | undefined;
    confirmationDate?: string | undefined;
    fairwayClass?: string | undefined;
    publicationDate: Date;
}

export interface FerryCreateDto {
    name: string;
    description?: string | undefined;
    location: Coordinate;
    roadNumber?: number | undefined;
    startNumber?: number | undefined;
    startDistanceMetre?: number | undefined;
    endNumber?: number | undefined;
    endDistanceMetre?: number | undefined;
    lengthMetre?: number | undefined;
    active: boolean;
    mapAreaIds?: number[] | undefined;
    maintainerOrganizationId: number;
}

export interface FerryEditDto {
    name: string;
    description?: string | undefined;
    location: Coordinate;
    roadNumber?: number | undefined;
    startNumber?: number | undefined;
    startDistanceMetre?: number | undefined;
    endNumber?: number | undefined;
    endDistanceMetre?: number | undefined;
    lengthMetre?: number | undefined;
    active: boolean;
    mapAreaIds?: number[] | undefined;
    maintainerOrganizationId: number;
}

export interface PaginatedListOfFerryListDto {
    results: FerryListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface FerryListDto {
    id: number;
    name: string;
    description?: string | undefined;
    location: Coordinate;
    roadNumber?: number | undefined;
    startNumber?: number | undefined;
    startDistanceMetre?: number | undefined;
    endNumber?: number | undefined;
    endDistanceMetre?: number | undefined;
    lengthMetre?: number | undefined;
    active: boolean;
    mapAreas?: MapAreaItemDto[] | undefined;
    maintainerOrganization: OrganizationListDto;
}

export interface FerryDetailsDto {
    id: number;
    name: string;
    description?: string | undefined;
    location: Coordinate;
    roadNumber?: number | undefined;
    startNumber?: number | undefined;
    startDistanceMetre?: number | undefined;
    endNumber?: number | undefined;
    endDistanceMetre?: number | undefined;
    lengthMetre?: number | undefined;
    active: boolean;
    mapAreas?: MapAreaItemDto[] | undefined;
    maintainerOrganization: OrganizationListDto;
}

export interface FolderAddDto {
    parentId: number;
    name?: string | undefined;
    organizationId?: number | undefined;
    mapAreaId?: number | undefined;
    seaSurveyId?: number | undefined;
    eventId?: number | undefined;
}

export interface MoveItemDto {
    source: number;
    destination: number;
}

export interface NodeRenameDto {
    newName?: string | undefined;
}

export interface FolderReturnDto {
    editable?: number[] | undefined;
    nodes?: ReturnNodeDto | undefined;
}

export interface NewNodeInfoDto {
    id: number;
    name?: string | undefined;
    isFolder: boolean;
    fileType?: string | undefined;
    fileExtension?: string | undefined;
    dataPath?: string | undefined;
    programManaged: boolean;
    parentId?: number | undefined;
    bytes: number;
    fullName?: string | undefined;
}

export interface NodeShareDto {
    expires?: Date | undefined;
    singleUse: boolean;
}

export interface PaginatedListOfSharedFileListDto {
    results: SharedFileListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface SharedFileListDto {
    id: number;
    key?: string | undefined;
    expires?: Date | undefined;
    singleUse: boolean;
    expired: boolean;
    nodeName?: string | undefined;
    fileExtension?: string | undefined;
    creatorName?: string | undefined;
    downloadCount: number;
}

export interface FleetCreateDto {
    fleetName: string;
    description?: string | undefined;
    items?: FleetItemIdDto[] | undefined;
}

export interface FleetItemIdDto {
    aisId?: number | undefined;
    equipmentItemId?: number | undefined;
    sortIndex?: number | undefined;
}

export interface FleetEditDto {
    fleetName?: string | undefined;
    description?: string | undefined;
    items?: FleetItemIdDto[] | undefined;
}

export interface PaginatedListOfFleetListDto {
    results: FleetListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface FleetListDto {
    id: number;
    fleetName: string;
    description?: string | undefined;
    organizationId: number;
}

export interface FleetDetailsDto {
    id: number;
    fleetName: string;
    description?: string | undefined;
    organizationId: number;
    fleetItems?: FleetItemDto[] | undefined;
}

export interface FleetItemDto {
    sortIndex?: number | undefined;
}

export interface GeopickingCreateDto {
    content?: string | undefined;
    location: GeopickingPoint;
    type: GeopickingTypeEnum;
    seaSurveyId: number;
}

export interface GeopickingPoint {
    x: number;
    y: number;
    z: number;
}

export enum GeopickingTypeEnum {
    Comment = 1,
}

export interface GeopickingEditDto {
    content?: string | undefined;
}

export interface PaginatedListOfGeopickingItemDto {
    results: GeopickingItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface GeopickingItemDto {
    id: number;
    content?: string | undefined;
    location: GeopickingPoint;
    createdTimestamp: Date;
    type: GeopickingTypeEnum;
    seaSurvey: SeaSurveyListDto;
    creator: UserListDto;
}

export interface SeaSurveyListDto {
    id: number;
    name: string;
    description?: string | undefined;
    archived: boolean;
    surveyStartTimestamp: Date;
    surveyEndTimestamp: Date;
    surveyor?: string | undefined;
    vessel?: string | undefined;
    sizeSquareMeters?: number | undefined;
    customer?: string | undefined;
    contact?: string | undefined;
    surveyMethodId?: number | undefined;
    surveyMethod?: SurveyMethodListDto | undefined;
    comparisonLevelId?: number | undefined;
    comparison?: ComparisonLevelListDto | undefined;
    comparisonLevelOffsetMm: number;
    additionalHeightOffsetMm: number;
    coordinateSystemId: number;
    coordinateSystem?: CoordinateSystemListDto | undefined;
    projectManager?: string | undefined;
    designer?: string | undefined;
    expert?: string | undefined;
    securityClassificationId?: number | undefined;
    securityClassification?: SecurityClassificationListDto | undefined;
    releaseTimestamp?: Date | undefined;
    mapAreas?: MapAreaItemDto[] | undefined;
    files?: ReturnNodeDto[] | undefined;
    multiPoly?: MultiPolygonDto | undefined;
    folderId: number;
    fileCount?: number | undefined;
    merge: boolean;
}

export interface SurveyMethodListDto {
    id: number;
    name: string;
}

export interface SecurityClassificationListDto {
    id: number;
    name: string;
}

export interface MultiPolygonDto {
    polygons?: Coordinate[][] | undefined;
    centroid?: Coordinate | undefined;
}

export interface Map3DObjectCreateDto {
    hierarchyNodeId: number;
    mapAreaId: number;
    assetType: AssetTypeEnum;
}

export enum AssetTypeEnum {
    IMAGERY = 1,
    TERRAIN = 2,
}

export interface PaginatedListOfMap3DObjectListDto {
    results: Map3DObjectListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface Map3DObjectListDto {
    id: number;
    name: string;
    cesiumId: number;
    mapArea: MapAreaItemDto;
    stateId: CesiumStateEnum;
    assetTypeId: AssetTypeEnum;
    percentComplete: number;
    node?: ReturnNodeDto | undefined;
}

export enum CesiumStateEnum {
    AWAITING_FILES = 1,
    NOT_STARTED = 2,
    IN_PROGRESS = 3,
    COMPLETE = 4,
    DATA_ERROR = 5,
    ERROR = 6,
}

export interface Map3DObjectDetailsDto {
    id: number;
    type?: string | undefined;
    url?: string | undefined;
    accessToken?: string | undefined;
    maxZ: number;
    minZ: number;
    elevationSettings?: string | undefined;
    wkt?: string | undefined;
}

export interface Map3DObjectSettingsUpdateDto {
    elevationSettings?: string | undefined;
}

export interface PaginatedListOfMapAreaItemDto {
    results: MapAreaItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface MapAreaCreateDto {
    name: string;
    type: MapAreaTypeEnum;
    projectID?: string | undefined;
    projectName?: string | undefined;
    reimariTSdGroupSDGROUP_IDs: number[];
}

export interface MapAreaEditDto {
    name: string;
    type: MapAreaTypeEnum;
    projectID?: string | undefined;
    projectName?: string | undefined;
    reimariTSdGroupSDGROUP_IDs: number[];
}

export interface PaginatedListOfNauticalWarningItemDto {
    results: NauticalWarningItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface NauticalWarningItemDto {
    id: number;
    location?: Coordinate | undefined;
    nauticalWarningId?: number | undefined;
    number?: number | undefined;
    areasFi?: string | undefined;
    areasSv?: string | undefined;
    areasEn?: string | undefined;
    locationFi?: string | undefined;
    locationSv?: string | undefined;
    locationEn?: string | undefined;
    contentsFi?: string | undefined;
    contentsSv?: string | undefined;
    contentsEn?: string | undefined;
    typeFi?: string | undefined;
    typeSv?: string | undefined;
    typeEn?: string | undefined;
    creationTime?: Date | undefined;
    validityStartTime?: Date | undefined;
    validityEndTime?: Date | undefined;
    publishingTime?: Date | undefined;
    notificator?: string | undefined;
}

export interface OperationFaultCreateDto {
    name: string;
}

export interface OperationFaultEditDto {
    name: string;
}

export interface PaginatedListOfOperationFaultListDto {
    results: OperationFaultListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface OperationTargetCreateDto {
    name: string;
}

export interface OperationTargetEditDto {
    name: string;
}

export interface PaginatedListOfOperationTargetListDto {
    results: OperationTargetListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface OperationTypeCreateDto {
    name: string;
}

export interface OperationTypeEditDto {
    name: string;
}

export interface PaginatedListOfOperationTypeListDto {
    results: OperationTypeListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface OrganizationCreateDto {
    name: string;
}

export interface OrganizationEditDto {
    name: string;
    address?: string | undefined;
}

export interface PaginatedListOfOrganizationListDto {
    results: OrganizationListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface OrganizationDetailsDto {
    id: number;
    name: string;
    address?: string | undefined;
}

export interface OrganizationRoleCreateDto {
    roleName?: string | undefined;
    baseAccess: boolean;
    organizationAdmin: boolean;
}

export interface OrganizationRoleEditDto {
    roleName?: string | undefined;
}

export interface PaginatedListOfOrganizationRoleListDto {
    results: OrganizationRoleListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface OrganizationRoleDetailsDto {
    roleName?: string | undefined;
    baseAccess: boolean;
    organizationAdmin: boolean;
    allowNotifications: boolean;
}

export interface OrganizationUserMoveDto {
    roleIds: number[];
    userId: number;
}

export interface OrganizationUserEditDto {
    roleIDs: number[];
}

export interface PaginatedListOfUserListDto {
    results: UserListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface PermissionItemDto {
    mapAreaId?: number | undefined;
    accessId: AccessEnum;
}

export interface PortCreateDto {
    name: string;
    description?: string | undefined;
    locodeId: number;
    points: Coordinate[];
    mapAreaIds?: number[] | undefined;
}

export interface PortEditDto {
    name: string;
    description?: string | undefined;
    locodeId: number;
    points: Coordinate[];
    mapAreaIds?: number[] | undefined;
}

export interface PaginatedListOfPortListDto {
    results: PortListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface PortCallCommentAddDto {
    comment?: string | undefined;
    portId: number;
    internal: boolean;
}

export interface PortCallCommentEditDto {
    comment?: string | undefined;
    internal: boolean;
}

export interface PaginatedListOfPortCallCommentDetailsDto {
    results: PortCallCommentDetailsDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface PortCallCommentDetailsDto {
    id: number;
    comment?: string | undefined;
    internal: boolean;
    port?: PortDetailsDto | undefined;
    creator?: UserListDto | undefined;
    modifiedUser?: UserListDto | undefined;
    portCallId: number;
    portCall?: PortCallDto | undefined;
    createdTime: Date;
    modifiedTime: Date;
}

export interface PortCallDto {
    portCallId: number;
    vesselName?: string | undefined;
    portToVisit?: string | undefined;
    prevPort?: string | undefined;
    discharge?: number | undefined;
    freeTextArrival?: string | undefined;
    freeTextDeparture?: string | undefined;
    metadataMmsi?: number | undefined;
    notLoading?: boolean | undefined;
    ata?: Date | undefined;
    ataTimestamp?: Date | undefined;
    atd?: Date | undefined;
    atdTimestamp?: Date | undefined;
    berthCode?: string | undefined;
    berthName?: string | undefined;
    eta?: Date | undefined;
    etaTimestamp?: Date | undefined;
    etd?: Date | undefined;
    etdTimestamp?: Date | undefined;
    portAreaCode?: string | undefined;
    portAreaName?: string | undefined;
}

export interface PortServiceUpdateDto {
    type: PortServiceTypeEnum;
    location?: Coordinate | undefined;
    name?: string | undefined;
    description?: string | undefined;
    availabilityInfo?: string | undefined;
}

export interface PortServiceCreateDto extends PortServiceUpdateDto {
    portId: number;
}

export enum PortServiceTypeEnum {
    Water = 1,
    Fuel = 2,
    Bollard = 3,
    Electricity = 4,
    Crane = 5,
    Other = 6,
}

export interface PaginatedListOfPortServiceItemDto {
    results: PortServiceItemDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface PortServiceItemDto {
    portServiceType: PortServiceTypeEnum;
    location?: Coordinate | undefined;
    name?: string | undefined;
    description?: string | undefined;
    availabilityInfo?: string | undefined;
    port?: PortListDto | undefined;
    id: number;
}

export interface ProjectAddDto {
    name?: string | undefined;
    projectId?: string | undefined;
    clientName?: string | undefined;
}

export interface ProjectEditDto {
    name?: string | undefined;
    projectId?: string | undefined;
    clientName?: string | undefined;
}

export interface PaginatedListOfProjectListDto {
    results: ProjectListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface PTOPProjectPOIDto {
    id?: number | undefined;
    coordinates?: Coordinate | undefined;
    type: PointOfInterestType;
    date: Date;
    description?: string | undefined;
}

export enum PointOfInterestType {
    Wreck = 0,
    Danger = 1,
    Misc = 2,
}

export interface PTOPFeatureListDto {
    id: number;
    area?: string | undefined;
    subArea?: string | undefined;
    vessel?: string | undefined;
    status?: string | undefined;
    state: FeatureState;
    progress: number;
}

export enum FeatureState {
    Valid = 0,
    MissingFromProject = 1,
    MissingFromGeometry = 2,
}

export interface WPRListDto {
    id: number;
    fullName?: string | undefined;
    bytes: number;
    latest: boolean;
}

export interface WPRCreateDto {
    mapImage?: string | undefined;
    templateNodeId: number;
}

export interface SdDropdownDto {
    types?: string[] | undefined;
    navigationTypes?: string[] | undefined;
    structures?: string[] | undefined;
    fairways?: string[] | undefined;
    owners?: string[] | undefined;
    componentTypes?: string[] | undefined;
    components?: string[] | undefined;
    jobArea?: string[] | undefined;
    actionTypes?: string[][] | undefined;
    faultStates?: string[] | undefined;
    faultTypes?: string[] | undefined;
}

export interface SdActionDropdownDto {
    types?: ActionType[] | undefined;
    workCategory?: ActionType[] | undefined;
    workClass?: string[][] | undefined;
    action?: string[][] | undefined;
    state?: ActionType[] | undefined;
    contractor?: string[] | undefined;
    sdTypes?: string[] | undefined;
    navigationClass?: string[] | undefined;
    structures?: string[] | undefined;
    jobAreas?: string[] | undefined;
    fairways?: string[] | undefined;
    owners?: string[] | undefined;
}

export interface ActionType {
    actioN_CDE?: number | undefined;
    codE_NME?: string | undefined;
}

export interface ActionDropdownSelections {
    type?: number | undefined;
    workCategory?: number | undefined;
    workClasses?: number[] | undefined;
    actions?: number[] | undefined;
}

export interface SdSearchDto {
    sdIdentifier?: string | undefined;
    deviceState?: string[] | undefined;
    subType?: string | undefined;
    type?: string | undefined;
    navigationType?: string | undefined;
    light?: boolean | undefined;
    light_?: string | undefined;
    structure?: string | undefined;
    actionTypes?: number[] | undefined;
    actionStartDate?: Date | undefined;
    actionEndDate?: Date | undefined;
    actionDone: boolean;
    contractArea?: string | undefined;
    owner?: string | undefined;
    fairway?: string | undefined;
    componentType?: string | undefined;
    component?: string | undefined;
    noComponent: boolean;
    points?: Coordinate[] | undefined;
}

export interface ActionSearchDto {
    actions?: number[] | undefined;
    workCategory?: number | undefined;
    workClasses?: number[] | undefined;
    actionExecutionStartDate?: Date | undefined;
    actionExecutionEndDate?: Date | undefined;
    state?: number | undefined;
    sdIdentifier?: string | undefined;
    deviceState?: string[] | undefined;
    subType?: string | undefined;
    type?: string | undefined;
    navigationType?: string | undefined;
    light?: boolean | undefined;
    structure?: string | undefined;
    contractArea?: string | undefined;
    owner?: string | undefined;
    fairway?: string | undefined;
    points?: Coordinate[] | undefined;
    actionDone: boolean;
}

export interface FaultSearchDto {
    startPosition?: number | undefined;
    count?: number | undefined;
    faultState?: string[] | undefined;
    faultType?: string | undefined;
    atonUnitIdOrName?: string | undefined;
    atonUnitType?: string | undefined;
    operational?: boolean | undefined;
    observedStartDate?: Date | undefined;
    observedEndDate?: Date | undefined;
    entryStartDate?: Date | undefined;
    entryEndDate?: Date | undefined;
    fixedStartDate?: Date | undefined;
    fixedEndDate?: Date | undefined;
    faultDaysMin?: number | undefined;
    faultDaysMax?: number | undefined;
    contractArea?: string | undefined;
    contractor?: string | undefined;
    owner?: string | undefined;
    fairway?: string | undefined;
    fairwayClass?: string | undefined;
    fairwayManagementClass?: string | undefined;
    points?: Coordinate[] | undefined;
}

export interface InSeaFullAtonDetails {
    buoyId?: number | undefined;
    name?: string | undefined;
    atoNNumber?: number | undefined;
    originalPosition?: InSeaAtonLocation | undefined;
    floating?: boolean | undefined;
    buoyType?: string | undefined;
    nightToDay?: Date | undefined;
    dayToNight?: Date | undefined;
    hdop?: number | undefined;
    lightDistance?: number | undefined;
    illuminationCounter?: number | undefined;
    opticalFeedbackLevel?: number | undefined;
    tiltAngle?: number | undefined;
    solarPanel24hProduction?: number | undefined;
    solarPanelCurrentMax?: number | undefined;
    secondaryBatteryVoltage?: number | undefined;
    beaconTemperature?: number | undefined;
    voltage?: number | undefined;
    calculatedDeviation?: number | undefined;
    photocellThreshold?: number | undefined;
    minimumVoltage?: number | undefined;
    flashTable?: string | undefined;
    powerConsumption?: number | undefined;
    installationPosition?: InSeaAtonLocation | undefined;
    maxDeviation?: number | undefined;
    defaultLedIntensity?: number | undefined;
    avg24Voltage?: number | undefined;
    min24Voltage?: number | undefined;
    currentPosition?: InSeaAtonLocation | undefined;
    communicationStatus?: string | undefined;
    commDeviceType?: string | undefined;
    smcFirmware?: string | undefined;
    gpsFirmware?: string | undefined;
    gpsHardware?: string | undefined;
    gsmFirmware?: string | undefined;
    gsmSoftware?: string | undefined;
    lastConnected?: Date | undefined;
    createdDate?: Date | undefined;
    activeAlarms?: number | undefined;
    activeWarnings?: number | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export interface InSeaAtonLocation {
    latitude?: number | undefined;
    longitude?: number | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export interface SeaSurveyVerifyDto {
    name: string;
    description?: string | undefined;
    archived: boolean;
    surveyStartTimestamp: Date;
    surveyEndTimestamp: Date;
    surveyor?: string | undefined;
    vessel?: string | undefined;
    sizeSquareMeters?: number | undefined;
    customer?: string | undefined;
    contact?: string | undefined;
    surveyMethodId?: number | undefined;
    comparisonLevelId?: number | undefined;
    comparisonLevelOffsetMm?: number | undefined;
    coordinateSystemId: number;
    projectManager?: string | undefined;
    designer?: string | undefined;
    expert?: string | undefined;
    securityClassificationId?: number | undefined;
    releaseTimestamp?: Date | undefined;
    mapAreaIds?: number[] | undefined;
    fileIds?: number[] | undefined;
    fileCount?: number | undefined;
    merge: boolean;
}

export interface SeaSurveyCreateDto extends SeaSurveyVerifyDto {
}

export interface SeaSurveyEditDto extends SeaSurveyVerifyDto {
}

export interface PaginatedListOfSeaSurveyListDto {
    results: SeaSurveyListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface SeaSurveyDetailsDto {
    id: number;
    name: string;
    description?: string | undefined;
    archived: boolean;
    surveyStartTimestamp: Date;
    surveyEndTimestamp: Date;
    surveyor?: string | undefined;
    vessel?: string | undefined;
    sizeSquareMeters?: number | undefined;
    customer?: string | undefined;
    contact?: string | undefined;
    surveyMethodId?: number | undefined;
    surveyMethod?: SurveyMethodListDto | undefined;
    comparisonLevelId?: number | undefined;
    comparison?: ComparisonLevelListDto | undefined;
    comparisonLevelOffsetMm: number;
    additionalHeightOffsetMm: number;
    coordinateSystemId: number;
    coordinateSystem?: CoordinateSystemListDto | undefined;
    projectManager?: string | undefined;
    designer?: string | undefined;
    expert?: string | undefined;
    securityClassificationId?: number | undefined;
    securityClassification?: SecurityClassificationListDto | undefined;
    releaseTimestamp?: Date | undefined;
    mapAreas?: MapAreaItemDto[] | undefined;
    files?: ReturnNodeDto[] | undefined;
    folderId: number;
    fileCount?: number | undefined;
    merge: boolean;
}

export interface FileInformationSettingsUpdateDto {
    elevationSettings?: string | undefined;
    intensitySettings?: string | undefined;
    pointSizeSettings?: string | undefined;
    attenuationSettings?: string | undefined;
    colorSettings?: string | undefined;
    staticColor?: string | undefined;
    coloringType?: string | undefined;
}

export interface SeaSurveyHeightOffsetDto {
    additionalHeightOffset: number;
}

export interface SecurityClassificationCreateDto {
    name: string;
}

export interface SecurityClassificationEditDto {
    name: string;
}

export interface PaginatedListOfSecurityClassificationListDto {
    results: SecurityClassificationListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface SurveyMethodCreateDto {
    name: string;
}

export interface SurveyMethodEditDto {
    name: string;
}

export interface PaginatedListOfSurveyMethodListDto {
    results: SurveyMethodListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface WindDto {
    id: number;
    location?: Coordinate | undefined;
    stationName?: string | undefined;
    stationCode: number;
    region?: string | undefined;
    windSpeedMeasurements?: WindSpeedMeasurement[] | undefined;
    windGustMeasurements?: WindGustMeasurement[] | undefined;
    windDirectionMeasurements?: WindDirectionMeasurement[] | undefined;
}

export interface WindSpeedMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface WindGustMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface WindDirectionMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface WaveDto {
    id: number;
    location?: Coordinate | undefined;
    stationName?: string | undefined;
    stationCode: number;
    region?: string | undefined;
    waveHeightMeasurements?: WaveHeightMeasurement[] | undefined;
    waveDirectionMeasurements?: WaveDirectionMeasurement[] | undefined;
}

export interface WaveHeightMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface WaveDirectionMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface SeaDto {
    id: number;
    location?: Coordinate | undefined;
    stationName?: string | undefined;
    stationCode: number;
    region?: string | undefined;
    seaLevelMeasurements?: SeaLevelMeasurement[] | undefined;
    seaTemperatureMeasurements?: SeaTemperatureMeasurement[] | undefined;
}

export interface SeaLevelMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface SeaTemperatureMeasurement {
    unit: string;
    value: number;
    timestamp: Date;
}

export interface VesselLocationHistoryDto {
    vesselMmsi: number;
    timeRangeTravelDistance: number;
    history?: HistoryData[] | undefined;
}

export interface HistoryData {
    totalTravelDistance: number;
    x: number;
    y: number;
    timeAtLocation: Date;
    distanceDelta: number;
    speed: number;
}

export interface PaginatedListOfAISVesselDto {
    results: AISVesselDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface PortCallV2Dto {
    portCallId: number;
    eventType?: string | undefined;
    eventTime: Date;
    recordTime: Date;
    eventTimeConfidenceLower?: Date | undefined;
    eventTimeConfidenceUpper?: Date | undefined;
    source?: string | undefined;
    mmsi: number;
    port?: string | undefined;
    portArea?: string | undefined;
    from?: string | undefined;
}

export interface PortCallCombinedDto {
    portCallId: number;
    vesselName?: string | undefined;
    portToVisit?: string | undefined;
    prevPort?: string | undefined;
    discharge?: number | undefined;
    freeTextArrival?: string | undefined;
    freeTextDeparture?: string | undefined;
    metadataMmsi?: number | undefined;
    notLoading?: boolean | undefined;
    ata?: Date | undefined;
    ataSource?: string | undefined;
    ataTimestamp?: Date | undefined;
    atd?: Date | undefined;
    atdSource?: string | undefined;
    atdTimestamp?: Date | undefined;
    berthCode?: string | undefined;
    berthName?: string | undefined;
    eta?: Date | undefined;
    etaSource?: string | undefined;
    etaTimestamp?: Date | undefined;
    etd?: Date | undefined;
    etdSource?: string | undefined;
    etdTimestamp?: Date | undefined;
    portAreaCode?: string | undefined;
    portAreaName?: string | undefined;
    additionalCalls?: TimeData[] | undefined;
    portCallComments?: PortCallCommentDetailsDto[] | undefined;
}

export interface TimeData {
    v2Id?: number | undefined;
    eventType?: string | undefined;
    eventTime: Date;
    recordTime: Date;
    eventTimeConfidenceLower?: Date | undefined;
    eventTimeConfidenceUpper?: Date | undefined;
    source?: string | undefined;
    mmsi: number;
    port?: string | undefined;
    portArea?: string | undefined;
    from?: string | undefined;
}

export interface LuodeDto {
    id: number;
    name?: string | undefined;
    x: number;
    y: number;
    measurements?: LuodeMeasurementDto[] | undefined;
}

export interface LuodeMeasurementDto {
    id: number;
    time: Date;
    waterLevel?: number | undefined;
    temperature?: number | undefined;
    direction?: number | undefined;
    speed?: number | undefined;
    battery?: number | undefined;
    flowSpeedWest?: number | undefined;
    flowSpeedMiddle?: number | undefined;
    flowSpeedEast?: number | undefined;
    northCellDirection?: number | undefined;
    northCellSpeed?: number | undefined;
    middleCellDirection?: number | undefined;
    middleCellSpeed?: number | undefined;
    southCellDirection?: number | undefined;
    southCellSpeed?: number | undefined;
}

export interface TrackerEditDto {
    name?: string | undefined;
    description?: string | undefined;
    organizationId?: number | undefined;
}

export interface PaginatedListOfElisaDeviceDto {
    results: ElisaDeviceDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface TrackerDeviceDtoOfElisaDeviceDataDto {
    name: string;
    description?: string | undefined;
    deviceId: string;
    data: ElisaDeviceDataDto;
    equipmentTracker?: EquipmentTrackerInfoDto | undefined;
}

export interface ElisaDeviceDto extends TrackerDeviceDtoOfElisaDeviceDataDto {
}

export interface ElisaDeviceDataDto {
    deviceId?: string | undefined;
    name?: string | undefined;
    eventtype?: string | undefined;
    lat: number;
    lon: number;
    status: number;
    devicetype?: string | undefined;
    imei?: string | undefined;
    parsertime?: Date | undefined;
    lastmodified?: Date | undefined;
}

export interface PaginatedListOfTaivalDeviceDto {
    results: TaivalDeviceDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface TrackerDeviceDtoOfTaivalDeviceDataDto {
    name: string;
    description?: string | undefined;
    deviceId: string;
    data: TaivalDeviceDataDto;
    equipmentTracker?: EquipmentTrackerInfoDto | undefined;
}

export interface TaivalDeviceDto extends TrackerDeviceDtoOfTaivalDeviceDataDto {
}

export interface TaivalDeviceDataDto {
    latitude: number;
    longitude: number;
    altitude: number;
    accuracy: number;
    locationTimestamp: Date;
    connectionReason: number;
    timeToLastGoodLocation: number;
    accX: number;
    accY: number;
    accZ: number;
    sensorTimestamp: Date;
    batteryLevel: number;
    deviceOperation?: string | undefined;
    batteryTimestamp: Date;
    activityTimestamp?: Date | undefined;
    inactiveTime?: number | undefined;
    activeTime?: number | undefined;
    motionTimestamp?: Date | undefined;
    motionTime?: number | undefined;
    stationaryTime?: number | undefined;
    impactTimestamp?: Date | undefined;
    impactActiveTime?: number | undefined;
    impactCount?: number | undefined;
}

export interface RouterKeyDto {
    primaryKey?: string | undefined;
}

export interface PaginatedListOfRouterListDto {
    results: RouterListDto[];
    currentPage: number;
    pageSize: number;
    totalCount: number;
}

export interface RouterListDto {
    deviceId: string;
    name: string;
    state: number;
    stateUpdatedDate: Date;
    reportedUpdatedDate: Date;
    desiredBuoys: BuoyDto[];
    reportedBuoys: BuoyDto[];
    mapAreas: MapAreaItemDto[];
}

export interface BuoyDto {
    buoyId: string;
    RSSI: number;
    batteryVoltage: number;
    lightControl: number;
    lightFeedback: number;
}

export interface RouterCreateDto {
    deviceId: string;
    name: string;
    buoys: BuoyDto[];
    mapAreaIds: number[];
}

export interface RouterEditDto {
    deviceId: string;
    name: string;
    buoys: BuoyDto[];
    mapAreaIds: number[];
}

export interface UserCreateDto {
    name: string;
    email: string;
    organizationId: number;
    roleIds: number[];
    globalAdmin: boolean;
}

export interface UserDetailsDto {
    id: number;
    name?: string | undefined;
    email?: string | undefined;
    organizationId: number;
    organizationRoles?: OrganizationRoleListDto[] | undefined;
}

export interface VesselAlarmSubscriptionDto {
    subscribedVesselAlarms?: { [key: string]: VesselAlarmType[]; } | undefined;
}

export interface UserLoginDto {
    id: number;
    azureId: string;
    name: string;
    email: string;
    globalAdmin: boolean;
    organization?: OrganizationDetailsDto | undefined;
    organizationRole?: OrganizationRoleDetailsDto | undefined;
    alarmsMuted: boolean;
    arrivalsMuted: boolean;
}

export interface UserMaterializedPermissionsDto {
    globalAdmin: boolean;
    permissions?: PermissionItemDto[] | undefined;
}

export interface GraphUserDto {
    id: number;
    phoneNumber?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}